(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7169],{

/***/ 77561:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/product-list",
      function () {
        return __webpack_require__(6821);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24495:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/filter.df2e3489.svg","height":14,"width":21});

/***/ }),

/***/ 75744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q3": function() { return /* binding */ handleViewDataLayer; },
/* harmony export */   "pV": function() { return /* binding */ pressKitDataLayer; },
/* harmony export */   "rk": function() { return /* binding */ getTabContentEventInfo; },
/* harmony export */   "rq": function() { return /* binding */ getPressRoomEventInfo; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "y": function() { return /* binding */ handleContactDataLayer; }
/* harmony export */ });
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55760);

const getEventInfo = (pressReleaseInfo, type, linkName)=>{
    const internalLinkName = linkName || type;
    var ref;
    return JSON.stringify({
        eventAction: "press room:press releases:".concat(type),
        eventName: "press room:press releases:".concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: "press room",
        internalLinkType: "press room:".concat(pressReleaseInfo["navTitle_s"] ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeText */ .oOy)(pressReleaseInfo["navTitle_s"]) : ""),
        internalLinkZoneName: "press room:press releases:main content area",
        internalLinkURL: linkName === "download" ? "n/a" : "".concat((ref = pressReleaseInfo["url_s"]) !== null && ref !== void 0 ? ref : "#"),
        clickInternalLinks: "true"
    });
};
const getTabContentEventInfo = function(linkName, type, linkType, analyticsLabel) {
    let url = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, zone = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    let zoneName;
    switch(type){
        case "email id":
            zoneName = linkType;
            break;
        case "share":
            zoneName = "contact";
            break;
        default:
            zoneName = zone !== null && zone !== void 0 ? zone : "contacts";
    }
    let internalLinkURL;
    switch(type){
        case "contact number":
            internalLinkURL = "tel:".concat((0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeDOMString */ .TRt)(url).replace("\n", ""));
            break;
        default:
            internalLinkURL = "n/a";
    }
    return JSON.stringify({
        eventAction: "press room:".concat(analyticsLabel, ":").concat(type),
        eventName: "press room:".concat(analyticsLabel, ":").concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_0__/* .sanitizeTextForAnalytics */ .T68)(linkName),
        internalLinkPosition: "press room",
        internalLinkType: "press room:".concat(linkType),
        internalLinkZoneName: "press room:".concat(analyticsLabel, ":").concat(zoneName),
        internalLinkURL,
        clickInternalLinks: "true"
    });
};
const handleContactDataLayer = (analyticsLabel)=>{
    return JSON.stringify({
        eventAction: "press room:".concat(analyticsLabel, ":print"),
        eventName: "press room:".concat(analyticsLabel, ":print"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "print",
        internalLinkPosition: "press room",
        internalLinkType: "press room:print",
        internalLinkZoneName: "press room:".concat(analyticsLabel, ":contacts"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const handleViewDataLayer = (analyticsLabel)=>{
    return JSON.stringify({
        eventAction: "press room:p".concat(analyticsLabel, ":view more"),
        eventName: "press room:p".concat(analyticsLabel, ":view more"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view more",
        internalLinkPosition: "press room",
        internalLinkType: "press room:view more",
        internalLinkZoneName: "press room:".concat(analyticsLabel, ":contacts"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const pressKitDataLayer = (pressKitInfo)=>{
    return JSON.stringify({
        eventAction: "press room:press kits:view press kit link",
        eventName: "press room:press kits:view press kit link",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view press kit",
        internalLinkPosition: "press room",
        internalLinkType: "press room:".concat(pressKitInfo["navTitle_s"] || ""),
        internalLinkZoneName: "press room:press kits:main content area",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const getPressRoomEventInfo = function(page, title, type) {
    let limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", all = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    page = page.replace("-", " ");
    return JSON.stringify({
        eventAction: "".concat(title, ":").concat(page, ":").concat(type),
        eventName: "".concat(title, ":").concat(page, ":").concat(type),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(limit || all),
        internalLinkPosition: "".concat(page),
        internalLinkType: "".concat(title, ":").concat(page, ":").concat(type),
        internalLinkZoneName: "".concat(title, ":").concat(page, ":main content area"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};


/***/ }),

/***/ 6821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ product_list; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(51857);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./components/Default/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(3282);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 206 modules
var AemGrid = __webpack_require__(94020);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx + 112 modules
var GlobalPageHeader = __webpack_require__(92058);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Filters/Filters/Filters.mjs + 12 modules
var Filters = __webpack_require__(25580);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Scrollbar/Scrollbar.mjs
var Scrollbar = __webpack_require__(12311);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./propTypes/plp.js

const plpPropsType = {
    handleOnClickPartsDiagramLink: (prop_types_default()).func.isRequired,
    propsProductCard: prop_types_default().shape({
        variantImages: prop_types_default().arrayOf((prop_types_default()).string).isRequired,
        product: prop_types_default().shape({
            sku: (prop_types_default()).string.isRequired,
            category: (prop_types_default()).string,
            slug: (prop_types_default()).string,
            productName: (prop_types_default()).string,
            productColor: (prop_types_default()).string,
            productStatus: (prop_types_default()).bool,
            productSaleable: (prop_types_default()).bool,
            productBasePrice: (prop_types_default()).string,
            productSalePrice: (prop_types_default()).string,
            globalPromotionPrice: (prop_types_default()).string,
            priceState: (prop_types_default()).string,
            productSuperSku: (prop_types_default()).string,
            productTileName: (prop_types_default()).string,
            defaultImageName: (prop_types_default()).string,
            productCollectionsName: (prop_types_default()).string,
            badgeValue: (prop_types_default()).string,
            discountPercent: (prop_types_default()).number,
            discountAmount: (prop_types_default()).number,
            productIsRetail: (prop_types_default()).bool,
            isBundleProduct: (prop_types_default()).bool,
            colors: (prop_types_default()).array,
            resourceName: (prop_types_default()).string,
            productNo: (prop_types_default()).string
        }).isRequired,
        originaldata: prop_types_default().shape({
            id: (prop_types_default()).string,
            masterSKU_s: (prop_types_default()).string,
            "Color.SKU.Details_ss": prop_types_default().arrayOf((prop_types_default()).string),
            Collapse_Description_s: (prop_types_default()).string,
            ProductDescriptionProductShort_s: (prop_types_default()).string,
            masterCustomerFacingSKU_s: (prop_types_default()).string,
            category1_s: (prop_types_default()).string,
            Product_Category: (prop_types_default()).string
        }),
        customerFacingSKU: (prop_types_default()).string,
        productDetails: prop_types_default().shape({
            checkbox: prop_types_default().shape({
                defaultChecked: (prop_types_default()).bool,
                checked: (prop_types_default()).bool,
                onClick: (prop_types_default()).func,
                tooltip: prop_types_default().shape({
                    label: (prop_types_default()).string,
                    width: (prop_types_default()).string
                })
            }),
            SKU: (prop_types_default()).object,
            colorSwatches: (prop_types_default()).object,
            additionalLink: (prop_types_default()).object
        }),
        image: prop_types_default().shape({
            src: (prop_types_default()).string,
            alt: (prop_types_default()).string,
            onError: (prop_types_default()).func,
            onClick: (prop_types_default()).func
        }),
        title: (prop_types_default()).object,
        description: (prop_types_default()).object,
        price: (prop_types_default()).object,
        isSaved: (prop_types_default()).bool,
        fullUrl: (prop_types_default()).string,
        tileUrl: (prop_types_default()).string
    }).isRequired,
    index: (prop_types_default()).number
};
const productListContextPropsType = {
    children: (prop_types_default()).node,
    data: (prop_types_default()).any,
    eventHandler: (prop_types_default()).any,
    plpData: (prop_types_default()).object,
    plpBadgeList: (prop_types_default()).any,
    disableCommerce: (prop_types_default()).any,
    swatchUrl: (prop_types_default()).any,
    language: (prop_types_default()).any,
    general: (prop_types_default()).any,
    socialMediaConfigs: (prop_types_default()).any,
    plpServletPath: (prop_types_default()).any,
    featureFlags: (prop_types_default()).any,
    facetQuery: (prop_types_default()).any,
    sortQuery: (prop_types_default()).any,
    locale: (prop_types_default()).any,
    skuPrepend: (prop_types_default()).any,
    plpPresetConfig: (prop_types_default()).any
};
const filtersUiPropTypes = {
    propsFilters: (prop_types_default()).object,
    propsScroll: (prop_types_default()).object,
    propsSortUI: (prop_types_default()).object
};
const sortUiPropTypes = {
    propsSortUI: (prop_types_default()).object.isRequired
};
const productListUIProps = {
    propsProductCard: (prop_types_default()).array,
    propsPagination: (prop_types_default()).object,
    propsSortUI: (prop_types_default()).object,
    propsScroll: (prop_types_default()).object,
    propsFilters: (prop_types_default()).object,
    filterClass: (prop_types_default()).string,
    tileClass: (prop_types_default()).string,
    rowCols: (prop_types_default()).number,
    width: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    smartCrop: (prop_types_default()).bool,
    componentProps: (prop_types_default()).object,
    getIsPresentOnDeviceStatus: prop_types_default().oneOfType([
        (prop_types_default()).func,
        (prop_types_default()).bool
    ]),
    setPromoData: (prop_types_default()).func,
    colVal: (prop_types_default()).object,
    promoData: (prop_types_default()).object,
    position: (prop_types_default()).number,
    promoCols: (prop_types_default()).object,
    partData: (prop_types_default()).object,
    onCloseModal: (prop_types_default()).func,
    svgFileMap: (prop_types_default()).object,
    totalCount: (prop_types_default()).number,
    handleOnClickPartsDiagramLink: (prop_types_default()).func
};
const listingPropTypes = {
    tmpData: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).array
    ]),
    headertmp: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).array
    ]),
    footertmp: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).array
    ]),
    ip: (prop_types_default()).string,
    adobeAnalytic: (prop_types_default()).any,
    globalScript: (prop_types_default()).any,
    footerScript: (prop_types_default()).any,
    analyticsData: (prop_types_default()).any,
    datalayerPageName: (prop_types_default()).string,
    plpData: (prop_types_default()).any,
    plpBadgeList: (prop_types_default()).any,
    disableCommerce: (prop_types_default()).bool,
    swatchUrl: (prop_types_default()).string,
    lang: (prop_types_default()).string,
    general: (prop_types_default()).object,
    socialMediaConfigs: (prop_types_default()).object,
    plpServletPathArray: (prop_types_default()).array,
    featureFlags: (prop_types_default()).object,
    gbhDataLayerCustom: (prop_types_default()).object,
    canonicalUrl: (prop_types_default()).string,
    seoPageScript: (prop_types_default()).string,
    breadCrumbApplicationJSonLd: (prop_types_default()).string,
    seoProperties: (prop_types_default()).object,
    pageData: (prop_types_default()).object,
    siteName: (prop_types_default()).string,
    query: (prop_types_default()).object,
    templateName: (prop_types_default()).string,
    locale: (prop_types_default()).string,
    skuPrepend: (prop_types_default()).string,
    plpPresetConfig: (prop_types_default()).object
};


;// CONCATENATED MODULE: ./components/ProductList/v3/ui/FiltersUI.jsx




const FiltersUI = (param)=>{
    let { propsFilters ={} , propsScroll ={} , propsSortUI ={} , isMobileViewport =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobileViewport ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters/* Filters */.x, {
            ...propsFilters,
            sortDropdownProps: propsSortUI === null || propsSortUI === void 0 ? void 0 : propsSortUI.sortDropdownProps
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Scrollbar/* Scrollbar */.L, {
            ...propsScroll,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters/* Filters */.x, {
                ...propsFilters,
                sortDropdownProps: propsSortUI === null || propsSortUI === void 0 ? void 0 : propsSortUI.sortDropdownProps
            })
        })
    });
};
FiltersUI.propTypes = filtersUiPropTypes;
/* harmony default export */ var ui_FiltersUI = (FiltersUI);

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/ProductCard.mjs + 18 modules
var ProductCard = __webpack_require__(3345);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/PlusIcon.mjs
var PlusIcon = __webpack_require__(35114);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./components/SaveToList/index.jsx
var SaveToList = __webpack_require__(4165);
// EXTERNAL MODULE: ./components/ListConfirmationModal/index.jsx + 1 modules
var ListConfirmationModal = __webpack_require__(63652);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./components/ProductList/v3/analytics/analytics.jsx
var analytics = __webpack_require__(77593);
// EXTERNAL MODULE: ./utils/product.js
var utils_product = __webpack_require__(29843);
// EXTERNAL MODULE: ./hooks/useProductFavorites.js
var useProductFavorites = __webpack_require__(69663);
;// CONCATENATED MODULE: ./hooks/useProductComparison.js








const useProductComparison = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [width] = (0,useWindowResize/* default */.Z)();
    const cartData = (0,es/* useSelector */.v9)((state)=>state.cart.data);
    const { getFavIconStatus , handleFavorite , handleLogin  } = (0,useProductFavorites/* default */.Z)();
    /**
   * Handles compare checkbox changes
   * @param {boolean} checked - New checkbox state
   * @param {Function} setIsChecked - State setter for isChecked
   * @param {Function} setInitialLoad - State setter for initialLoad
   * @param {Object} propsProductCard - Product card props
   * @param {number} index - Product index
   * @param {String} locale - Product locale
   * @param {String} skuPrepend - SKU prepend string
   * @param {Object} general - General config information
   * @param {Object} updateProductCard - Function to update the product card
   */ const handleCompare = (checked, setIsChecked, setInitialLoad, propsProductCard, index, locale, skuPrepend, general)=>{
        setIsChecked(checked);
        setInitialLoad(false);
        (0,analytics/* dataLayerPush */.lQ)(t("kf.compare.label.compare"), checked ? "add" : "remove", "compare", checked, propsProductCard, index, cartData, locale, skuPrepend, general);
    };
    const updateCompare = (isChecked, param)=>{
        let { propsProductCard , comparedProducts , productCategory , setCompareErrorMessage , setIsChecked , productSavedToList , userListItemsSkusRef , favoritesRef , masterSKU , productDataId , colorSwatches , compareErrorMessage , setUpdatedProductCard , setInitialLoad , index , setLoginFavouriteCallback , setOpenModal , setDeleteFromList , setShowAddToList , toasterContent , general , presetConf , plpServletPath , plpLocalState , isSaveProductToList , isAuthenticated , locale , skuPrepend , updatedProductCard  } = param;
        var ref, ref1, ref2;
        const product = propsProductCard.originaldata;
        const sku = propsProductCard.product.sku;
        let isAllowed = false;
        if (isChecked) {
            let variantFlag = false;
            if (comparedProducts.length < 4) {
                const allVariantSkus = comparedProducts === null || comparedProducts === void 0 ? void 0 : comparedProducts.map((a)=>{
                    const variantSkus = a["variantList.sku_ss"] || [];
                    return [
                        ...variantSkus,
                        a.masterSKU_s || a.sku_s
                    ].filter(Boolean);
                }).flat();
                if (allVariantSkus === null || allVariantSkus === void 0 ? void 0 : allVariantSkus.includes(sku)) {
                    variantFlag = true;
                }
                if (productCategory !== "" && productCategory !== (product === null || product === void 0 ? void 0 : product.Product_Category)) {
                    // Product category mismatch - show error message and remove from compare
                    setCompareErrorMessage(t("kf.compare.validation.sameCategory"));
                    setIsChecked(false);
                    (0,utils_product/* removeFromCompareProduct */.Zj)(sku);
                } else {
                    isAllowed = true;
                    const checkExist = comparedProducts.some((prod)=>prod.compareSku === sku);
                    if (!checkExist) (0,utils_product/* addToCompareProduct */.dX)(sku, product);
                }
            } else if (variantFlag && "compare_products_v1" === "compare_products_v2") {} else {
                // Max products limit reached
                setCompareErrorMessage(t("kf.plp.error.maxProduct"));
                setIsChecked(false);
                (0,utils_product/* removeFromCompareProduct */.Zj)(sku);
            }
        } else {
            // Unchecking product
            (0,utils_product/* removeFromCompareProduct */.Zj)(sku);
        }
        const variantImages = (ref = propsProductCard.variantImages) === null || ref === void 0 ? void 0 : ref.filter((img)=>{
            return propsProductCard.product.sku === (img === null || img === void 0 ? void 0 : img.split("|")[0]);
        });
        let imgUrl = ((ref1 = propsProductCard.image) === null || ref1 === void 0 ? void 0 : ref1.src) || "";
        if (variantImages) {
            var ref3;
            imgUrl = (0,utils/* getPresetUrl */.v$)(width, width <= 1024 ? 2 : 3, general.swatchUrl, (ref3 = variantImages[0]) === null || ref3 === void 0 ? void 0 : ref3.split("|")[1], presetConf);
        }
        const updatedCard = {
            ...propsProductCard,
            ...updatedProductCard,
            image: {
                ...propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.image,
                src: imgUrl,
                onError: (e)=>{
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = [
                        image_missing/* default */.Z
                    ][0].src;
                },
                onClick: (e)=>{
                    (0,utils_product/* redirectToPdp */.Sv)(e, propsProductCard.product.category, propsProductCard.product.slug, propsProductCard.product.sku, plpServletPath, general);
                }
            },
            isSaved: getFavIconStatus(isSaveProductToList, productSavedToList, userListItemsSkusRef, favoritesRef, masterSKU, productDataId, null),
            saveCTA: {
                onClick: (e)=>{
                    if (isAuthenticated) {
                        handleFavorite(e, {
                            favoritesRef,
                            userListItemsSkusRef,
                            productDataId,
                            masterSKU,
                            setOpenModal,
                            setDeleteFromList,
                            setShowAddToList,
                            setLoginFavouriteCallback,
                            toasterContent,
                            propsProductCard,
                            cartData,
                            isChecked,
                            index,
                            locale,
                            skuPrepend,
                            general,
                            isSaveProductToList,
                            isAuthenticated
                        });
                    } else {
                        handleLogin(e, cartData, propsProductCard, setLoginFavouriteCallback, locale, skuPrepend, general);
                    }
                }
            },
            productDetails: {
                ...propsProductCard.productDetails,
                ...updatedProductCard.productDetails,
                colorSwatches,
                ...width > 1023 && {
                    checkbox: {
                        ...(ref2 = propsProductCard.productDetails) === null || ref2 === void 0 ? void 0 : ref2.checkbox,
                        label: t("kf.compare.label.compare"),
                        defaultChecked: isAllowed,
                        checked: isAllowed,
                        onClick: (e)=>{
                            handleCompare(e.target.checked, setIsChecked, setInitialLoad, propsProductCard, index, locale, skuPrepend, general) // pass product data and modied responseprocesser
                            ;
                        }
                    }
                }
            }
        };
        if (compareErrorMessage) {
            updatedCard.productDetails.checkbox.tooltip = {
                label: compareErrorMessage,
                width: "200px"
            };
        }
        setUpdatedProductCard(updatedCard);
    };
    return {
        handleCompare,
        updateCompare
    };
};
/* harmony default export */ var hooks_useProductComparison = (useProductComparison);

// EXTERNAL MODULE: ./responseProcessors/plpResponseProcessor.js
var plpResponseProcessor = __webpack_require__(86255);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
;// CONCATENATED MODULE: ./utils/indexDB.js
/**
 * Simple IndexedDB utility for storing large data
 */ 
const isSupported = ()=>{
    return  true && "indexedDB" in window;
};
/**
 * Opens IndexedDB connection
 * @return {Promise<IDBDatabase>}
 */ const openDB = ()=>{
    return new Promise((resolve, reject)=>{
        const request = indexedDB.open(constants.DB_NAME, constants.DB_VERSION);
        request.onerror = ()=>reject(request.error);
        request.onsuccess = ()=>resolve(request.result);
        request.onupgradeneeded = (event)=>{
            const db = event.target.result;
            if (!db.objectStoreNames.contains(constants.STORE_NAME)) {
                db.createObjectStore(constants.STORE_NAME, {
                    keyPath: "key"
                });
            }
        };
    });
};
/**
 * Save data to IndexedDB
 * @param {string} key - Storage key
 * @param {any} data - Data to store
 * @return {Promise<void>}
 */ const setItem = async (key, data)=>{
    try {
        const db = await openDB();
        const transaction = db.transaction(constants.STORE_NAME, constants.READ_WRITE);
        const store = transaction.objectStore(constants.STORE_NAME);
        return new Promise((resolve, reject)=>{
            const request = store.put({
                key,
                data
            });
            request.onsuccess = ()=>{
                db.close();
                resolve();
            };
            request.onerror = ()=>{
                db.close();
                reject(request.error);
            };
        });
    } catch (error) {
        console.error("IndexedDB setItem error:", error);
        throw error;
    }
};
/**
 * Get data from IndexedDB
 * @param {string} key - Storage key
 * @return {Promise<any>}
 */ const getItem = async (key)=>{
    try {
        const db = await openDB();
        const transaction = db.transaction(constants.STORE_NAME, constants.READ_ONLY);
        const store = transaction.objectStore(constants.STORE_NAME);
        return new Promise((resolve, reject)=>{
            const request = store.get(key);
            request.onsuccess = ()=>{
                var ref;
                db.close();
                resolve(((ref = request.result) === null || ref === void 0 ? void 0 : ref.data) || null);
            };
            request.onerror = ()=>{
                db.close();
                reject(request.error);
            };
        });
    } catch (error) {
        console.error("IndexedDB getItem error:", error);
        return null;
    }
};
/**
 * Remove data from IndexedDB
 * @param {string} key - Storage key
 * @return {Promise<void>}
 */ const removeItem = async (key)=>{
    try {
        const db = await openDB();
        const transaction = db.transaction(constants.STORE_NAME, constants.READ_WRITE);
        const store = transaction.objectStore(constants.STORE_NAME);
        return new Promise((resolve, reject)=>{
            const request = store.delete(key);
            request.onsuccess = ()=>{
                db.close();
                resolve();
            };
            request.onerror = ()=>{
                db.close();
                reject(request.error);
            };
        });
    } catch (error) {
        console.error("IndexedDB removeItem error:", error);
        throw error;
    }
};
/**
 * Clear all data from IndexedDB
 * @return {Promise<void>}
 */ const clear = async ()=>{
    try {
        const db = await openDB();
        const transaction = db.transaction(STORE_NAME, READ_WRITE);
        const store = transaction.objectStore(STORE_NAME);
        return new Promise((resolve, reject)=>{
            const request = store.clear();
            request.onsuccess = ()=>{
                db.close();
                resolve();
            };
            request.onerror = ()=>{
                db.close();
                reject(request.error);
            };
        });
    } catch (error) {
        console.error("IndexedDB clear error:", error);
        throw error;
    }
};

;// CONCATENATED MODULE: ./components/ProductList/v3/ProductCardHOC.jsx


























const QuickView = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(2374), __webpack_require__.e(5490)]).then(__webpack_require__.bind(__webpack_require__, 10322)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10322)
            ]
    }
});
const productCardHOC = (WrappedComponent)=>{
    return function WithProductCardWrapper(param) {
        let { propsProductCard , handleOnClickPartsDiagramLink , index  } = param;
        var ref, ref1, ref2;
        const [width] = (0,useWindowResize/* default */.Z)();
        const persona = (0,helper/* getUserPersona */.shu)();
        const { t  } = (0,esm/* useTranslation */.$G)();
        const dispatch = (0,es/* useDispatch */.I0)();
        const saveButtonRef = (0,react.useRef)(null);
        const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
        const [showAddToList, setShowAddToList] = (0,react.useState)(false);
        const [deleteFromList, setDeleteFromList] = (0,react.useState)(false);
        const [productSavedToList, setProductSavedToList] = (0,react.useState)(false);
        const [openModal, setOpenModal] = (0,react.useState)(false);
        const [toasterContent, setToasterContent] = (0,react.useState)({
            successMessage: "",
            unfavoriteSuccessMessage: ""
        });
        const [hoverColor, setHoverColor] = (0,react.useState)(null);
        const { comparedProducts , category: productCategory  } = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
        const { isViewDetailClicked  } = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv);
        const { toaster  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
        const cartData = (0,es/* useSelector */.v9)((state)=>state.cart.data);
        const [initialLoad, setInitialLoad] = (0,react.useState)(true);
        const [scrollY, setScrollY] = (0,react.useState)(0);
        const [compareErrorMessage, setCompareErrorMessage] = (0,react.useState)("") // for compare
        ;
        const [isChecked, setIsChecked] = (0,react.useState)(comparedProducts.some((prod)=>prod.compareSku === propsProductCard.product.sku));
        const [updatedProductCard, setUpdatedProductCard] = (0,react.useState)(propsProductCard);
        const [displayPriceState, setDisplayPrice] = (0,react.useState)("");
        const [slashedPriceState, setSlashedPrice] = (0,react.useState)("");
        const [showQuickViewModal, setShowQuickViewModal] = (0,react.useState)(false);
        const skuCode = propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.sku;
        const productDataId = (0,react.useMemo)(()=>{
            var ref;
            return (ref = propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.originaldata["id"]) === null || ref === void 0 ? void 0 : ref.split("|")[0];
        }, [
            propsProductCard
        ]);
        const masterSKU = (0,react.useMemo)(()=>{
            return propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.originaldata["masterSKU_s"];
        }, [
            propsProductCard
        ]);
        const { general , plpServletPath , featureFlags , isAuthenticated , plpLocalState , locale , skuPrepend , componentProps , currencySign , plpLocalState: { cardsData =[]  } = {} , isServerData =true , quickViewAuthData , setPlpLocalState  } = useProductContext();
        const presetConf = JSON.parse(componentProps.presetConfigs);
        const { product: { bundleFlag ="no" , isBundleProduct =false , sku: psku = "" , allVariantsDiscontinued =false  } = {}  } = propsProductCard || {};
        const isBundle = bundleFlag === "Yes";
        const isCanadaSite = (general === null || general === void 0 ? void 0 : general.siteName) === "kohler-canada";
        let retailerExclusive = false;
        if ((propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.originaldata["ProductIsRetail_s"]) === "true") {
            retailerExclusive = true;
        }
        const isQuickViewShow = isBundle || (psku === null || psku === void 0 ? void 0 : psku.includes("BNDL")) || allVariantsDiscontinued || retailerExclusive;
        // SKU logic - use variantList.sku_ss[0] for bundles, masterSKU for regular products
        const effectiveSKU = (0,react.useMemo)(()=>{
            try {
                var ref, ref1, ref2;
                if (isBundle && Array.isArray(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.originaldata) === null || ref === void 0 ? void 0 : ref["variantList.sku_ss"]) && ((ref1 = propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.originaldata["variantList.sku_ss"]) === null || ref1 === void 0 ? void 0 : ref1[0])) {
                    return propsProductCard.originaldata["variantList.sku_ss"][0];
                }
                if (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref2 = propsProductCard.originaldata) === null || ref2 === void 0 ? void 0 : ref2["sku_s"]) {
                    return propsProductCard.originaldata["sku_s"];
                }
                console.warn("SKU data is missing. Returning default SKU.");
                return "UNKNOWN_SKU" // Default value
                ;
            } catch (error) {
                console.error("Error computing effectiveSKU:", error);
                return "ERROR_SKU" // Fallback value in case of unexpected errors
                ;
            }
        }, [
            isBundle,
            propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.originaldata,
            masterSKU
        ]);
        const { handleCompare , updateCompare  } = hooks_useProductComparison();
        const { getFavIconStatus , handleFavorite , handleLogin  } = (0,useProductFavorites/* default */.Z)();
        const { userListItemsSkus ={}  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx, (prev, next)=>JSON.stringify(prev) === JSON.stringify(next));
        const favorites = (0,es/* useSelector */.v9)((state)=>{
            var ref;
            return ((ref = state.favorites.favorites) === null || ref === void 0 ? void 0 : ref.lineItems) || [];
        }, (prev, next)=>JSON.stringify(prev) === JSON.stringify(next));
        const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false  } = featureFlags;
        const favoritesRef = (0,react.useRef)(favorites);
        const userListItemsSkusRef = (0,react.useRef)(userListItemsSkus);
        // Handle focus on save button to ensure it's visible past navigation menu
        const handleSaveButtonFocus = ()=>{
            if (!saveButtonRef.current) return;
            // Determine row cols based on width (same logic as ProductList)
            // Get the element's position
            const rect = saveButtonRef.current.getBoundingClientRect();
            const navHeight = 100 // Approximate navigation menu height, adjust as needed
            ;
            // Check if element is hidden behind navigation
            if (rect.top < navHeight) {
                // Scroll to make the element visible with some offset
                const scrollOffset = window.pageYOffset + rect.top - navHeight - 20;
                window.scrollTo({
                    top: scrollOffset,
                    behavior: "smooth"
                });
            }
        };
        const handleQuickViewCTAClick = async (e, sku)=>{
            var ref;
            const targetSku = sku ? sku : propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.sku;
            // Check if IndexedDB is supported, throw error if not
            if (!isSupported()) {
                const error = new Error(constants.INDEXEDDB_NOT_SUPPORTED_ERROR);
                console.error(error);
                throw error;
            }
            try {
                var ref1;
                // Store data in IndexedDB
                await setItem("plpCardsData+".concat(window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href), JSON.stringify(cardsData));
                await setItem("fromPDP", true);
                await setItem("plpsku", targetSku);
                await setItem("isServerData", isServerData);
            } catch (error1) {
                console.error("Failed to store data:", error1);
            }
            const scrollY = window === null || window === void 0 ? void 0 : window.scrollY;
            setScrollY(scrollY);
            setShowQuickViewModal(true);
            // add data layer code here
            (0,analytics/* colorDataLayerHandle */.ZB)(propsProductCard, index, cartData, locale, skuPrepend, general, constants.QUICK_VIEW);
        };
        const handleQuickViewHide = async ()=>{
            if (scrollY) {
                window.scrollTo({
                    top: parseInt(scrollY, 10),
                    behavior: "instant"
                });
            }
            setScrollY(0);
            setShowQuickViewModal(false);
            // Clean up IndexedDB
            try {
                var ref;
                await removeItem("fromPDP");
                await removeItem("plpCardsData+".concat(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href));
                await removeItem("plpsku");
                await removeItem("isServerData");
            } catch (error) {
                console.error("Failed to clean up data:", error);
            }
            // add data layer code here
            (0,analytics/* colorDataLayerHandle */.ZB)(propsProductCard, index, cartData, locale, skuPrepend, general, "".concat(constants.QUICK_VIEW_MODAL, ":").concat(constants.CLOSE));
        };
        (0,react.useEffect)(()=>{
            let timeoutId;
            if (isViewDetailClicked !== "VIEW_DETAILS_CLICKED" && !showQuickViewModal) {
                timeoutId = setTimeout(async ()=>{
                    try {
                        var ref;
                        await removeItem("fromPDP");
                        await removeItem("plpCardsData+".concat(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href));
                        await removeItem("plpsku");
                        await removeItem("isServerData");
                    } catch (error) {
                        console.error("Failed to clean up data:", error);
                    }
                }, 500) // Remove after 500 milliseconds
                ;
            }
            return ()=>{
                if (timeoutId) clearTimeout(timeoutId);
            };
        }, [
            isViewDetailClicked,
            showQuickViewModal
        ]);
        (0,react.useEffect)(()=>{
            const { displayPrice , hasPriceRange , slashedPrice , skuVariantPrice  } = (0,plpResponseProcessor/* calculateProductPricing */.W5)(propsProductCard, persona, general, currencySign, isServerData);
            // Handle bundle pricing - use priceStartingAt with persona-specific pricing
            let finalDisplayPrice = displayPrice;
            if (isBundle && persona) {
                var ref;
                const bundlePriceKey = "priceStartingAt.".concat(persona, "_d");
                const bundlePrice = propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.originaldata) === null || ref === void 0 ? void 0 : ref[bundlePriceKey];
                if (bundlePrice) {
                    finalDisplayPrice = "Starting at ".concat(currencySign).concat(bundlePrice);
                } else {
                    var ref1;
                    // Fallback to min_price if persona-specific price is not available
                    const fallbackPrice = propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref1 = propsProductCard.originaldata) === null || ref1 === void 0 ? void 0 : ref1["min_price"];
                    if (fallbackPrice) {
                        finalDisplayPrice = "Starting at ".concat(currencySign).concat(fallbackPrice);
                    }
                }
            }
            setUpdatedProductCard((prev)=>{
                var ref, ref1, ref2;
                return {
                    ...prev,
                    price: {
                        text: finalDisplayPrice,
                        component: "a",
                        href: "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.category, propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref1 = propsProductCard.product) === null || ref1 === void 0 ? void 0 : ref1.slug, plpServletPath, general), "?skuId=").concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref2 = propsProductCard.product) === null || ref2 === void 0 ? void 0 : ref2.sku)
                    },
                    hasPriceRange: hasPriceRange,
                    skuVariantPrice: skuVariantPrice
                };
            });
            if (slashedPrice !== null) {
                setUpdatedProductCard((prev)=>{
                    var ref, ref1, ref2;
                    return {
                        ...prev,
                        slashedPrice: {
                            text: !isBundle && slashedPrice,
                            component: "a",
                            href: "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.category, propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref1 = propsProductCard.product) === null || ref1 === void 0 ? void 0 : ref1.slug, plpServletPath, general), "?skuId=").concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref2 = propsProductCard.product) === null || ref2 === void 0 ? void 0 : ref2.sku)
                        }
                    };
                });
            }
            setDisplayPrice(finalDisplayPrice);
            setSlashedPrice(slashedPrice);
        }, [
            isAuthenticated,
            width,
            propsProductCard,
            isBundle
        ]);
        (0,react.useEffect)(()=>{
            let timeoutId;
            if (compareErrorMessage) {
                timeoutId = setTimeout(()=>{
                    setCompareErrorMessage("");
                }, 2000);
            }
            if (compareErrorMessage === "" && !initialLoad) {
                var ref, ref1, ref2, ref3;
                const updatedCard = {
                    ...propsProductCard,
                    ...updatedProductCard,
                    // Hide heart icon (save/favorite functionality) for bundles
                    ...!isBundle && {
                        isSaved: getFavIconStatus(isSaveProductToList, productSavedToList, userListItemsSkusRef, favoritesRef, effectiveSKU, productDataId, null),
                        saveCTA: {
                            ref: saveButtonRef,
                            "aria-label": "Add ".concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.productName, " to list"),
                            onFocus: handleSaveButtonFocus,
                            onClick: (e)=>{
                                if (isAuthenticated) {
                                    handleFavorite(e, {
                                        favoritesRef,
                                        userListItemsSkusRef,
                                        productDataId,
                                        masterSKU: effectiveSKU,
                                        setOpenModal,
                                        setDeleteFromList,
                                        setShowAddToList,
                                        setLoginFavouriteCallback,
                                        toasterContent,
                                        propsProductCard,
                                        cartData,
                                        isChecked,
                                        index,
                                        locale,
                                        skuPrepend,
                                        general,
                                        isSaveProductToList,
                                        isAuthenticated
                                    });
                                } else {
                                    handleLogin(e, cartData, propsProductCard, setLoginFavouriteCallback, locale, skuPrepend, general);
                                }
                            }
                        }
                    },
                    productDetails: {
                        ...propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.productDetails,
                        colorSwatches,
                        // Add Bundle tag for bundle products
                        tags: (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref1 = propsProductCard.productDetails) === null || ref1 === void 0 ? void 0 : ref1.tags) || [],
                        // Hide compare checkbox for bundles and only show on desktop
                        ...width > 1023 && !isBundle && !isBundleProduct && {
                            checkbox: {
                                ...propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref2 = propsProductCard.productDetails) === null || ref2 === void 0 ? void 0 : ref2.checkbox,
                                "aria-label": "Add ".concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref3 = propsProductCard.product) === null || ref3 === void 0 ? void 0 : ref3.productName, "  to compare rack."),
                                label: t("kf.compare.label.compare"),
                                onClick: (e)=>{
                                    handleCompare(e.target.checked, setIsChecked, setInitialLoad, propsProductCard, index, locale, skuPrepend, general, updatedProductCard) // pass product data and modied responseprocesser
                                    ;
                                }
                            }
                        }
                    }
                };
                setUpdatedProductCard(updatedCard);
            }
            return ()=>{
                if (timeoutId) clearTimeout(timeoutId);
            };
        }, [
            compareErrorMessage,
            initialLoad
        ]);
        (0,react.useEffect)(()=>{
            // Update checkbox state when comparedProducts changes
            const isProductCompared = comparedProducts.some((prod)=>{
                var ref;
                return (prod === null || prod === void 0 ? void 0 : prod.compareSku) === (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.sku);
            });
            if (isChecked !== isProductCompared) {
                setIsChecked(isProductCompared);
            }
        }, [
            comparedProducts,
            propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref1 = propsProductCard.product) === null || ref1 === void 0 ? void 0 : ref1.sku
        ]);
        // Transform color swatches to include event handlers properly
        // Hide color swatches for bundles where Bundle_s === "Yes"
        const colorSwatches = (0,react.useMemo)(()=>{
            var ref, ref1, ref2, ref3;
            if (isBundle) {
                return null // Don't show color swatches for bundles
                ;
            }
            return {
                ...propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.productDetails) === null || ref === void 0 ? void 0 : ref.colorSwatches,
                colors: propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref1 = propsProductCard.productDetails) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colorSwatches) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.map((item, index)=>{
                    var ref, ref1, ref2, ref3;
                    let slug = propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.slug;
                    const colorSkuSlugListDetails = propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref1 = propsProductCard.originaldata) === null || ref1 === void 0 ? void 0 : ref1["colorSkuSlugListDetails_ss"];
                    if ((propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.isCollapsePLP) && !isBundle && !(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref2 = propsProductCard.product) === null || ref2 === void 0 ? void 0 : ref2.isBundleProduct) && colorSkuSlugListDetails && colorSkuSlugListDetails.length > 0) {
                        const slugFound = colorSkuSlugListDetails.find((img)=>{
                            return item.sku === (img === null || img === void 0 ? void 0 : img.split("|")[0]);
                        });
                        if (slugFound) {
                            var ref4;
                            const slugArray = slugFound === null || slugFound === void 0 ? void 0 : slugFound.split("|");
                            slug = slugArray[slugArray.length - 1] || (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref4 = propsProductCard.product) === null || ref4 === void 0 ? void 0 : ref4.slug);
                        }
                    }
                    const finalUrl = "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref3 = propsProductCard.product) === null || ref3 === void 0 ? void 0 : ref3.category, slug, plpServletPath, general), "?skuId=").concat(item === null || item === void 0 ? void 0 : item.sku);
                    return {
                        ...item,
                        component: "a",
                        href: finalUrl,
                        onMouseEnter: ()=>{
                            var ref, ref1, ref2;
                            setHoverColor({
                                sku: item === null || item === void 0 ? void 0 : item.sku,
                                customerFacingSKU: item === null || item === void 0 ? void 0 : item.customerFacingSKU,
                                image: (ref2 = propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.productDetails) === null || ref === void 0 ? void 0 : (ref1 = ref.colorSwatches) === null || ref1 === void 0 ? void 0 : ref1.colors[index]) === null || ref2 === void 0 ? void 0 : ref2.image,
                                displaySKU: "K-" + (item === null || item === void 0 ? void 0 : item.sku)
                            });
                        },
                        onMouseLeave: ()=>{
                            setHoverColor(null);
                        }
                    };
                }),
                onColorSelected: (e)=>{
                    var ref, ref1;
                    const matchFound = propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.find((item)=>{
                        return typeof item === "string" && (item === null || item === void 0 ? void 0 : item.split("|")[0]) === e;
                    });
                    if (matchFound) {
                        redirectToPdpHandler(e, matchFound === null || matchFound === void 0 ? void 0 : matchFound.split("|")[2], "color");
                    }
                }
            };
        }, [
            propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref2 = propsProductCard.productDetails) === null || ref2 === void 0 ? void 0 : ref2.colorSwatches,
            isBundle
        ]);
        const redirectToPdpHandler = async function(e, sku) {
            let type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            var ref;
            setPlpLocalState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            (0,analytics/* colorDataLayerHandle */.ZB)(propsProductCard, index, cartData, locale, skuPrepend, general, type);
            const targetSku = sku || (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.sku);
            try {
                var ref1;
                // Store data in IndexedDB
                await setItem("plpCardsData+".concat(window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href), JSON.stringify(cardsData));
                await setItem("fromPDP", true);
                await setItem("plpsku", targetSku);
                await setItem("isServerData", isServerData);
            } catch (error) {
                console.error("Failed to store data:", error);
            }
        };
        // Merge hover state and update image based on selected color
        (0,react.useMemo)(()=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
            const eventInfoServiceParts = (0,analytics/* getEventInfo */.wQ)(t("kf.search.partsdiagram").toLowerCase(), null, true, false, false, "", false, propsProductCard, index);
            const productInfo = (0,analytics/* getProductInfo */.Cn)("", true, false, cartData, propsProductCard, locale, skuPrepend, general);
            let swatchImageId = "";
            const colorSkuSlugListDetails = propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.originaldata) === null || ref === void 0 ? void 0 : ref["colorSkuSlugListDetails_ss"];
            let swatchImages = (propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.isCollapsePLP) && !isBundle && !isBundleProduct && colorSkuSlugListDetails && colorSkuSlugListDetails.length > 0 ? colorSkuSlugListDetails : propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.variantImages;
            swatchImages = swatchImages === null || swatchImages === void 0 ? void 0 : swatchImages.find((img)=>{
                var ref;
                return (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.sku) === (img === null || img === void 0 ? void 0 : img.split("|")[0]);
            });
            let imgUrl = "";
            let defaultImageName = "";
            // Check if Bundle_s parameter is "true" and use BundlePLPImageURL
            if ((propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref1 = propsProductCard.originaldata) === null || ref1 === void 0 ? void 0 : ref1["Bundle_s"]) === "Yes" && (propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.originaldata["BundlePLPImageURL_s"])) {
                imgUrl = propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.originaldata["BundlePLPImageURL_s"];
            } else if (swatchImages) {
                var ref26;
                swatchImages = swatchImages === null || swatchImages === void 0 ? void 0 : swatchImages.split("|");
                const swatchIndex = (propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.isCollapsePLP) && !isBundle && !isBundleProduct && colorSkuSlugListDetails && colorSkuSlugListDetails.length > 0 ? swatchImages.length - 2 : swatchImages.length - 1;
                const swatchImageValues = (ref26 = swatchImages[swatchIndex]) === null || ref26 === void 0 ? void 0 : ref26.split("/");
                swatchImageId = swatchImageValues && swatchImageValues.length > 0 ? swatchImageValues[swatchImageValues.length - 1] : "";
                imgUrl = (0,utils/* getPresetUrl */.v$)(width, width < 1024 ? 2 : 3, general.swatchUrl, swatchImageId, presetConf);
                defaultImageName = swatchImageId;
            }
            let updatedCard = {
                ...propsProductCard,
                ...updatedProductCard,
                defaultImageName: defaultImageName,
                href: "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref2 = propsProductCard.product) === null || ref2 === void 0 ? void 0 : ref2.category, propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref3 = propsProductCard.product) === null || ref3 === void 0 ? void 0 : ref3.slug, plpServletPath, general), "?skuId=").concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref4 = propsProductCard.product) === null || ref4 === void 0 ? void 0 : ref4.sku),
                image: {
                    ...propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.image,
                    src: imgUrl,
                    onError: (e)=>{
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = image_missing/* default.src */.Z.src;
                    },
                    onMouseEnter: (e)=>{
                        handleLightOnPLPProduct(e, imgUrl);
                    },
                    onMouseLeave: (e)=>{
                        handleLightOffPLPProduct(e, imgUrl);
                    },
                    onClick: redirectToPdpHandler
                },
                title: {
                    ...propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.title,
                    onClick: redirectToPdpHandler,
                    component: "a",
                    href: "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref5 = propsProductCard.product) === null || ref5 === void 0 ? void 0 : ref5.category, propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref6 = propsProductCard.product) === null || ref6 === void 0 ? void 0 : ref6.slug, plpServletPath, general), "?skuId=").concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref7 = propsProductCard.product) === null || ref7 === void 0 ? void 0 : ref7.sku)
                },
                description: {
                    ...propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.description,
                    // Use Collapse_Description_s for bundle products
                    ...isBundle && (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref8 = propsProductCard.originaldata) === null || ref8 === void 0 ? void 0 : ref8["Collapse_Description_s"]) && {
                        text: propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.originaldata["Collapse_Description_s"]
                    },
                    onClick: (e)=>{
                        redirectToPdpHandler(e);
                    },
                    component: "a",
                    href: "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref9 = propsProductCard.product) === null || ref9 === void 0 ? void 0 : ref9.category, propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref10 = propsProductCard.product) === null || ref10 === void 0 ? void 0 : ref10.slug, plpServletPath, general), "?skuId=").concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref11 = propsProductCard.product) === null || ref11 === void 0 ? void 0 : ref11.sku)
                },
                price: {
                    ...updatedProductCard.price,
                    onClick: (e)=>{
                        redirectToPdpHandler(e);
                    },
                    component: "a",
                    href: "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref12 = propsProductCard.product) === null || ref12 === void 0 ? void 0 : ref12.category, propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref13 = propsProductCard.product) === null || ref13 === void 0 ? void 0 : ref13.slug, plpServletPath, general), "?skuId=").concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref14 = propsProductCard.product) === null || ref14 === void 0 ? void 0 : ref14.sku)
                },
                // Hide heart icon (save/favorite functionality) for bundles
                ...!isBundle && {
                    isSaved: getFavIconStatus(isSaveProductToList, productSavedToList, userListItemsSkusRef, favoritesRef, effectiveSKU, productDataId, null),
                    saveCTA: {
                        ref: saveButtonRef,
                        "aria-label": "Add ".concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref15 = propsProductCard.product) === null || ref15 === void 0 ? void 0 : ref15.productName, " to list"),
                        onFocus: handleSaveButtonFocus,
                        onClick: (e)=>{
                            if (isAuthenticated) {
                                handleFavorite(e, {
                                    favoritesRef,
                                    userListItemsSkusRef,
                                    productDataId,
                                    masterSKU: effectiveSKU,
                                    setOpenModal,
                                    setDeleteFromList,
                                    setShowAddToList,
                                    setLoginFavouriteCallback,
                                    toasterContent,
                                    propsProductCard,
                                    cartData,
                                    isChecked,
                                    index,
                                    locale,
                                    skuPrepend,
                                    general,
                                    isSaveProductToList,
                                    isAuthenticated
                                });
                            } else {
                                handleLogin(e, cartData, propsProductCard, setLoginFavouriteCallback, locale, skuPrepend, general);
                            }
                        }
                    }
                },
                productDetails: {
                    ...propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.productDetails,
                    SKU: {
                        ...propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref16 = propsProductCard.productDetails) === null || ref16 === void 0 ? void 0 : ref16.SKU,
                        onClick: (e)=>{
                            redirectToPdpHandler(e);
                        },
                        component: "a",
                        href: "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref17 = propsProductCard.product) === null || ref17 === void 0 ? void 0 : ref17.category, propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref18 = propsProductCard.product) === null || ref18 === void 0 ? void 0 : ref18.slug, plpServletPath, general), "?skuId=").concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref19 = propsProductCard.product) === null || ref19 === void 0 ? void 0 : ref19.sku)
                    },
                    colorSwatches,
                    // Add Bundle tag for bundle products
                    tags: (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref20 = propsProductCard.productDetails) === null || ref20 === void 0 ? void 0 : ref20.tags) || [],
                    // Hide compare checkbox for bundles and only show on desktop
                    ...width > 1023 && !isBundle && !isBundleProduct && {
                        checkbox: {
                            ...propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref21 = propsProductCard.productDetails) === null || ref21 === void 0 ? void 0 : ref21.checkbox,
                            label: t("kf.compare.label.compare"),
                            "aria-label": "Add ".concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref22 = propsProductCard.product) === null || ref22 === void 0 ? void 0 : ref22.productName, "  to compare rack."),
                            checked: isChecked,
                            defaultChecked: undefined,
                            onClick: (e)=>{
                                handleCompare(e.target.checked, setIsChecked, setInitialLoad, propsProductCard, index, locale, skuPrepend, general);
                            }
                        }
                    },
                    // Hide service parts for bundles
                    ...!isBundle && {
                        additionalLink: {
                            text: (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref23 = propsProductCard.product) === null || ref23 === void 0 ? void 0 : ref23.resourceName) && (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref24 = propsProductCard.product) === null || ref24 === void 0 ? void 0 : ref24.productNo) ? t("kf.search.serviceparts") : "",
                            href: "#",
                            "aria-label": "See Service Parts for ".concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref25 = propsProductCard.product) === null || ref25 === void 0 ? void 0 : ref25.productName),
                            onClick: ()=>{
                                handleOnClickPartsDiagramLink(propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.product);
                                // updating page content type for service parts click
                                const pageEvent = window.pageObj || {};
                                const pageType = (0,helper/* getPageType */.C2B)();
                                const updatedPageEvent = {
                                    ...pageEvent,
                                    pageInfo: {
                                        ...pageEvent.pageInfo || {},
                                        contentType: pageType
                                    }
                                };
                                window.adobeDataLayer.push({
                                    event: "cmp:click",
                                    page: updatedPageEvent,
                                    eventInfo: eventInfoServiceParts,
                                    productInfo: productInfo
                                });
                            }
                        }
                    }
                }
            };
            if (hoverColor === null || hoverColor === void 0 ? void 0 : hoverColor.sku) {
                var ref27, ref28, ref29, ref30;
                // update sku based on hover color
                const selectedSku = updatedCard === null || updatedCard === void 0 ? void 0 : (ref27 = updatedCard.variantColors) === null || ref27 === void 0 ? void 0 : ref27.find((color)=>{
                    return (color === null || color === void 0 ? void 0 : color.split("|")[5]) === (hoverColor === null || hoverColor === void 0 ? void 0 : hoverColor.customerFacingSKU) || (color === null || color === void 0 ? void 0 : color.split("|")[5]) === (hoverColor === null || hoverColor === void 0 ? void 0 : hoverColor.displaySKU);
                });
                const selectedSKUPrice = updatedCard === null || updatedCard === void 0 ? void 0 : (ref28 = updatedCard.skuVariantPrice) === null || ref28 === void 0 ? void 0 : ref28.find((elem)=>{
                    return (elem === null || elem === void 0 ? void 0 : elem.split("|")[0]) === (hoverColor === null || hoverColor === void 0 ? void 0 : hoverColor.customerFacingSKU) || (elem === null || elem === void 0 ? void 0 : elem.split("|")[0]) === (hoverColor === null || hoverColor === void 0 ? void 0 : hoverColor.sku);
                });
                // If a selected SKU is found, update the productDetails.SKU
                if (selectedSku) {
                    var ref31;
                    updatedCard.productDetails.SKU = {
                        ...updatedCard === null || updatedCard === void 0 ? void 0 : (ref31 = updatedCard.productDetails) === null || ref31 === void 0 ? void 0 : ref31.SKU,
                        text: selectedSku === null || selectedSku === void 0 ? void 0 : selectedSku.split("|")[5]
                    };
                }
                // Update image based on selected color
                let swatchImageId1 = "";
                let swatchImages1 = (propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.isCollapsePLP) && !isBundle && !isBundleProduct && (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref29 = propsProductCard.originaldata) === null || ref29 === void 0 ? void 0 : (ref30 = ref29["colorSkuSlugListDetails_ss"]) === null || ref30 === void 0 ? void 0 : ref30.length) > 0 ? propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.originaldata["colorSkuSlugListDetails_ss"] : propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.variantImages;
                swatchImages1 = swatchImages1 === null || swatchImages1 === void 0 ? void 0 : swatchImages1.find((img)=>{
                    return hoverColor && hoverColor.sku === (img === null || img === void 0 ? void 0 : img.split("|")[0]);
                });
                if (swatchImages1) {
                    var ref32, ref33, ref34, ref35, ref36;
                    swatchImages1 = swatchImages1 === null || swatchImages1 === void 0 ? void 0 : swatchImages1.split("|");
                    const swatchIndex1 = (propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.isCollapsePLP) && !isBundle && !isBundleProduct && ((ref32 = propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.originaldata["colorSkuSlugListDetails_ss"]) === null || ref32 === void 0 ? void 0 : ref32.length) > 0 ? swatchImages1.length - 2 : swatchImages1.length - 1;
                    const swatchImageValues1 = (ref33 = swatchImages1[swatchIndex1]) === null || ref33 === void 0 ? void 0 : ref33.split("/");
                    swatchImageId1 = swatchImageValues1 && swatchImageValues1.length > 0 ? swatchImageValues1[swatchImageValues1.length - 1] : "";
                    const imgUrl1 = (0,utils/* getPresetUrl */.v$)(width, width < 1024 ? 2 : 3, general.swatchUrl, swatchImageId1, presetConf);
                    updatedCard.defaultImageName = swatchImageId1;
                    updatedCard.image = {
                        ...updatedCard.image,
                        src: imgUrl1,
                        onError: (e)=>{
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = image_missing/* default.src */.Z.src;
                        },
                        alt: (hoverColor === null || hoverColor === void 0 ? void 0 : (ref34 = hoverColor.image) === null || ref34 === void 0 ? void 0 : ref34.alt) || ""
                    };
                    updatedCard.price = {
                        ...updatedCard === null || updatedCard === void 0 ? void 0 : updatedCard.price,
                        ...!(updatedCard === null || updatedCard === void 0 ? void 0 : updatedCard.hasPriceRange) && {
                            text: (0,plpResponseProcessor/* formatPrice */.T4)(selectedSKUPrice === null || selectedSKUPrice === void 0 ? void 0 : selectedSKUPrice.split("|")[2], currencySign),
                            component: "a",
                            href: "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref35 = propsProductCard.product) === null || ref35 === void 0 ? void 0 : ref35.category, propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref36 = propsProductCard.product) === null || ref36 === void 0 ? void 0 : ref36.slug, plpServletPath, general), "?skuId=").concat(selectedSKUPrice === null || selectedSKUPrice === void 0 ? void 0 : selectedSKUPrice.split("|")[0])
                        }
                    };
                }
            }
            // on mouse leave display old price
            if (typeof (hoverColor === null || hoverColor === void 0 ? void 0 : hoverColor.sku) === "undefined") {
                var ref37, ref38, ref39;
                updatedCard = {
                    ...updatedCard,
                    price: {
                        text: displayPriceState,
                        component: "a",
                        href: "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref37 = propsProductCard.product) === null || ref37 === void 0 ? void 0 : ref37.category, propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref38 = propsProductCard.product) === null || ref38 === void 0 ? void 0 : ref38.slug, plpServletPath, general), "?skuId=").concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref39 = propsProductCard.product) === null || ref39 === void 0 ? void 0 : ref39.sku)
                    }
                };
                if (slashedPriceState !== "" && slashedPriceState !== null) {
                    var ref40, ref41, ref42;
                    updatedCard = {
                        ...updatedCard,
                        slashedPrice: {
                            text: !isBundle && slashedPriceState,
                            component: "a",
                            href: "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref40 = propsProductCard.product) === null || ref40 === void 0 ? void 0 : ref40.category, propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref41 = propsProductCard.product) === null || ref41 === void 0 ? void 0 : ref41.slug, plpServletPath, general), "?skuId=").concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref42 = propsProductCard.product) === null || ref42 === void 0 ? void 0 : ref42.sku)
                        }
                    };
                }
            }
            if (!isQuickViewShow && !isCanadaSite) {
                var ref43;
                updatedCard.quickViewCTA = {
                    label: t("kf.plp.product.quick.view.label"),
                    "aria-label": "Open Quick View for  ".concat(propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref43 = propsProductCard.product) === null || ref43 === void 0 ? void 0 : ref43.productName),
                    icon: PlusIcon/* PlusIcon */.p,
                    onClick: (e)=>{
                        var ref;
                        handleQuickViewCTAClick(e, propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.sku);
                    }
                };
            }
            setUpdatedProductCard({
                ...updatedProductCard,
                ...updatedCard
            });
        }, [
            propsProductCard,
            hoverColor === null || hoverColor === void 0 ? void 0 : hoverColor.sku,
            width,
            isAuthenticated
        ]);
        (0,react.useEffect)(()=>{
            if (!initialLoad) {
                updateCompare(isChecked, {
                    propsProductCard,
                    comparedProducts,
                    productCategory,
                    setCompareErrorMessage,
                    setIsChecked,
                    productSavedToList,
                    userListItemsSkusRef,
                    favoritesRef,
                    masterSKU: effectiveSKU,
                    productDataId,
                    colorSwatches,
                    compareErrorMessage,
                    setUpdatedProductCard,
                    setInitialLoad,
                    index,
                    setLoginFavouriteCallback,
                    setOpenModal,
                    setDeleteFromList,
                    setShowAddToList,
                    toasterContent,
                    general,
                    presetConf,
                    plpServletPath,
                    plpLocalState,
                    isSaveProductToList,
                    isAuthenticated,
                    locale,
                    skuPrepend,
                    updatedProductCard
                });
            }
        }, [
            isChecked,
            initialLoad
        ]);
        (0,react.useEffect)(()=>{
            favoritesRef.current = favorites;
            const isCurrentlyFavorite = favorites === null || favorites === void 0 ? void 0 : favorites.some((fav)=>fav.productId === productDataId);
            const newIsSaved = getFavIconStatus(isSaveProductToList, productSavedToList, userListItemsSkusRef, favoritesRef, effectiveSKU, productDataId, isCurrentlyFavorite);
            setUpdatedProductCard((prev)=>{
                if (prev.isSaved !== newIsSaved) {
                    return {
                        ...prev,
                        isSaved: newIsSaved
                    };
                }
                return prev;
            });
        }, [
            favorites.length
        ]);
        (0,react.useEffect)(()=>{
            userListItemsSkusRef.current = userListItemsSkus;
            const isCurrentlyFavorite = !!userListItemsSkus[effectiveSKU];
            const newIsSaved = getFavIconStatus(isSaveProductToList, productSavedToList, userListItemsSkusRef, favoritesRef, effectiveSKU, productDataId, isCurrentlyFavorite);
            setUpdatedProductCard((prev)=>{
                if (prev.isSaved !== newIsSaved) {
                    return {
                        ...prev,
                        isSaved: newIsSaved
                    };
                }
                return prev;
            });
        }, [
            userListItemsSkus,
            effectiveSKU
        ]);
        const setToasterMessage = async ()=>{
            if (!isEmpty_default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
                const { successMessage , unfavoriteSuccessMessage  } = toaster.content;
                setToasterContent({
                    successMessage: await (0,helper/* getShortenedUrl */.Ppy)(successMessage),
                    unfavoriteSuccessMessage: await (0,helper/* getShortenedUrl */.Ppy)(unfavoriteSuccessMessage)
                });
            }
        };
        const handleLightOnPLPProduct = (e)=>{
            if (componentProps === null || componentProps === void 0 ? void 0 : componentProps.hoverImageTag) {
                var ref;
                var ref1;
                const imagesVarints = (ref1 = propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.productVariantImages) !== null && ref1 !== void 0 ? ref1 : [];
                const hoverImage = imagesVarints.find((imageString)=>{
                    var ref;
                    const imageDetails = imageString.split("|");
                    return imageDetails[2] === componentProps.hoverImageTag && imageDetails[0] === (propsProductCard === null || propsProductCard === void 0 ? void 0 : (ref = propsProductCard.product) === null || ref === void 0 ? void 0 : ref.sku);
                });
                if (hoverImage) {
                    const hoverImageDetails = hoverImage.split("|");
                    const imgUrlNew = (0,utils/* getPresetUrl */.v$)(width, width < 1024 ? 2 : 3, general.swatchUrl, hoverImageDetails[1], presetConf);
                    e.currentTarget.src = imgUrlNew;
                }
            }
        };
        const handleLightOffPLPProduct = (e, imgUrl)=>{
            if (componentProps === null || componentProps === void 0 ? void 0 : componentProps.hoverImageTag) {
                e.currentTarget.src = imgUrl;
            }
        };
        (0,react.useEffect)(()=>{
            setToasterMessage();
        }, []);
        (0,react.useEffect)(()=>{
            if (loginFavouriteCallback && isAuthenticated) {
                if (isSaveProductToList) {
                    dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)()).unwrap().then((res)=>{
                        const userlistSKUS = res[0][1];
                        if (userlistSKUS[effectiveSKU]) {
                            setOpenModal(true);
                            setDeleteFromList(true);
                        } else {
                            handleFavorite(loginFavouriteCallback, {
                                favoritesRef,
                                userListItemsSkusRef,
                                productDataId,
                                masterSKU: effectiveSKU,
                                setOpenModal,
                                setDeleteFromList,
                                setShowAddToList,
                                setLoginFavouriteCallback,
                                toasterContent,
                                propsProductCard,
                                cartData,
                                isChecked,
                                index,
                                locale,
                                skuPrepend,
                                general,
                                isSaveProductToList,
                                isAuthenticated,
                                skipDataLayer: true
                            });
                        }
                    });
                } else {
                    handleFavorite(loginFavouriteCallback, {
                        favoritesRef,
                        userListItemsSkusRef,
                        productDataId,
                        masterSKU: effectiveSKU,
                        setOpenModal,
                        setDeleteFromList,
                        setShowAddToList,
                        setLoginFavouriteCallback,
                        toasterContent,
                        propsProductCard,
                        cartData,
                        isChecked,
                        index,
                        locale,
                        skuPrepend,
                        general,
                        isSaveProductToList,
                        isAuthenticated
                    });
                }
            }
        }, [
            loginFavouriteCallback,
            isAuthenticated
        ]);
        const deleteFromPLPDataLayer = ()=>{
            const productInfo = (0,analytics/* getProductInfo */.Cn)("", true, false, cartData, propsProductCard, locale, skuPrepend, general);
            (0,analytics/* removeProductFromListDataLayerPush */.qW)("delete from list", productInfo);
        };
        const handleDeleteFromList = ()=>{
            setProductSavedToList(false);
            const productInfo = (0,analytics/* getProductInfo */.Cn)("", true, false, cartData, propsProductCard, locale, skuPrepend, general);
            (0,analytics/* removeProductFromListDataLayerPush */.qW)("delete from list", productInfo);
        };
        const handleSaveToListAnalyticsInfo = ()=>{
            const productInfo = (0,analytics/* getProductInfo */.Cn)("", true, false, cartData, propsProductCard, locale, skuPrepend, general);
            (0,analytics/* removeProductFromListDataLayerPush */.qW)("save to List", productInfo);
        };
        const handleSaveToListSuccessCallBack = ()=>{
            setProductSavedToList(true);
        };
        let modalComponent = null;
        if (openModal) {
            modalComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(ListConfirmationModal/* default */.Z, {
                openConforMationModal: openModal,
                deleteFromList: deleteFromList,
                deleteFromPLP: true,
                deleteFromPLPDataLayer: deleteFromPLPDataLayer,
                closeConformationModal: ()=>{
                    setOpenModal(false);
                },
                list: userListItemsSkus[skuCode],
                deleteConfirmationModal: ()=>{
                    handleDeleteFromList();
                }
            });
        } else if (showAddToList) {
            modalComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveToList/* default */.Z, {
                productSku: skuCode,
                showListSaveAndCreate: showAddToList,
                listSaveAndCreateClose: ()=>{
                    setShowAddToList(false);
                },
                fromPLP: true,
                plpAddToListAnalytics: ()=>{
                    handleSaveToListAnalyticsInfo();
                },
                handleSuccessCallBack: ()=>handleSaveToListSuccessCallBack()
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-list-tile__wrapper wow",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, {
                    ...updatedProductCard
                }),
                modalComponent,
                showQuickViewModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                    showModal: showQuickViewModal,
                    onModalClose: handleQuickViewHide,
                    className: "quickview-modal",
                    fromPLP: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickView, {
                        productData: propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.originaldata,
                        closeModal: handleQuickViewHide,
                        authorData: quickViewAuthData,
                        quickViewSelectedSku: skuCode,
                        plp: true
                    })
                }) : null
            ]
        });
    };
};
// PropTypes for the wrapped component
productCardHOC.propTypes = plpPropsType;
/* harmony default export */ var ProductCardHOC = (productCardHOC);

;// CONCATENATED MODULE: ./components/ProductList/v3/ui/ProductCardUI.jsx



const ProductCardUI = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* ProductCard */.I, {
        ...props
    });
};
/* harmony default export */ var ui_ProductCardUI = (ProductCardHOC(ProductCardUI));

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Filters/FilterBar/FilterBar.mjs + 2 modules
var FilterBar = __webpack_require__(46812);
;// CONCATENATED MODULE: ./components/ProductList/v3/ui/SortUI.jsx



const SortUI = (param)=>{
    let { propsSortUI ={}  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterBar/* FilterBar */.f, {
        ...propsSortUI
    });
};
SortUI.propTypes = sortUiPropTypes;
/* harmony default export */ var ui_SortUI = (SortUI);

// EXTERNAL MODULE: ./components/ProductList/v3/styles/ProductList.module.scss
var ProductList_module = __webpack_require__(58231);
var ProductList_module_default = /*#__PURE__*/__webpack_require__.n(ProductList_module);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/PromotionalTilePLP/PromotionalTilePLP.mjs + 2 modules
var PromotionalTilePLP = __webpack_require__(22367);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Controls/Pagination/Pagination.mjs + 1 modules
var Pagination = __webpack_require__(71077);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./components/PartsViewer/v2/PartsViewer.jsx + 182 modules
var PartsViewer = __webpack_require__(70159);
// EXTERNAL MODULE: ./utils/textUtils.js
var textUtils = __webpack_require__(89299);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
;// CONCATENATED MODULE: ./components/ProductList/v3/analytics/promoTileAnalytics.js
// promoTileAnalytics.js
/**
 * Event handler for promotional tile clicks that sends analytics data to Adobe DataLayer.
 *
 * This function listens for click events on promotional tiles with the data attribute
 * `data-datalayer-id="kds-element-promotile"` and extracts analytics data from the
 * clicked element to push to the Adobe DataLayer for tracking purposes.
 *
 * The function performs the following operations:
 * 1. Finds the closest promotional tile element using the CSS selector
 * 2. Extracts event information from `data-datalayer-data` attribute
 * 3. Extracts component information from `data-datalayer-component` attribute
 * 4. Pushes a 'cmp:click' event to Adobe DataLayer with page, event, and component data
 *
 * Note: Requires window.adobeDataLayer and window.pageObj to be available globally.
 *
 * @export
 * @function handlePromoTileDatalayerClick
 * @param {Event} e - The DOM click event object containing the target element
 * @return {void}
 * @example
 * // Add event listener to document for promo tile clicks
 * document.addEventListener('click', handlePromoTileDatalayerClick);
 * @since 1.0.0
 */ const handlePromoTileDatalayerClick = (e)=>{
    const target = e.target.closest('[data-datalayer-id="kds-element-promotile"]');
    if (target) {
        var ref, ref1, ref2, ref3;
        console.log("Promo Tile Clicked", target.attributes);
        const eventInfo = JSON.parse(target === null || target === void 0 ? void 0 : (ref = target.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref["data-datalayer-data"]) === null || ref1 === void 0 ? void 0 : ref1.nodeValue) || "{}";
        const componentInfo = JSON.parse(target === null || target === void 0 ? void 0 : (ref2 = target.attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2["data-datalayer-component"]) === null || ref3 === void 0 ? void 0 : ref3.nodeValue) || "{}";
        if ( true && window.adobeDataLayer) {
            const pageEvent = window.pageObj || {};
            window.adobeDataLayer.push({
                event: "cmp:click",
                page: pageEvent,
                eventInfo,
                componentInfo
            });
        }
    }
};
const getPromoEventInfo = (ctatitle, ctalink, parent)=>{
    var ref, ref1;
    let eventInfo;
    if ( true && ((ref = window.location) === null || ref === void 0 ? void 0 : (ref1 = ref.pathname) === null || ref1 === void 0 ? void 0 : ref1.includes("search"))) {
        eventInfo = {
            eventAction: "search results:products:main content area:".concat(ctatitle),
            eventName: "search results:products:main content area:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "search",
            internalLinkType: "search results:internal campaign",
            internalLinkZoneName: "search results:products:main content area",
            internalLinkURL: window.location.origin + ctalink,
            clickInternalLinks: "true"
        };
    } else if ((parent === null || parent === void 0 ? void 0 : parent.toLowerCase()) === "Dynamic Search") {
        eventInfo = {
            eventAction: "search results:products:main content area:".concat(ctatitle),
            eventName: "search results:products:main content area:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "suggested search",
            internalLinkType: "suggested search results:internal campaign",
            internalLinkZoneName: "suggested search results:top products results",
            internalLinkURL:  true ? window.location.origin + ctalink : 0,
            clickInternalLinks: "true"
        };
    } else {
        eventInfo = {
            eventAction: "plp:".concat(ctatitle),
            eventName: "plp:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "plp",
            internalLinkType: "plp:internal campaign",
            internalLinkZoneName: "plp:promo tiles",
            internalLinkURL:  true ? window.location.origin + ctalink : 0,
            clickInternalLinks: "true"
        };
    }
    return eventInfo;
};

;// CONCATENATED MODULE: ./components/ProductList/v3/ui/ProductListUI.jsx

















const ProductListUI = (param)=>{
    let { propsPagination , propsSortUI , propsScroll , propsFilters , propsProductCard , filterClass , tileClass , componentProps , getIsPresentOnDeviceStatus =true , position , promoCols , partData , onCloseModal , svgFileMap , handleOnClickPartsDiagramLink , isMobileViewport , repeatPromo , scene7BaseUrl , dmScene7AccountName  } = param;
    const productCardSKUs = [];
    // Parse repeatPromo to determine if promo should repeat
    const shouldRepeatPromo = (()=>{
        try {
            return JSON.parse(repeatPromo);
        } catch (e) {
            return false;
        }
    })();
    const [actionLink, setActionLink] = (0,react.useState)("");
    const [width] = (0,useWindowResize/* default */.Z)();
    const [promoLinks, setPromoLinks] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        const parsed = (0,helper/* safeParseJSON */.NXl)(componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfjson);
        (0,utils_location/* getShortenedUrl */.Pp)(parsed === null || parsed === void 0 ? void 0 : parsed.ctaLink).then((res)=>setActionLink(res));
    }, [
        componentProps
    ]);
    const parsedXFJSON = (0,helper/* safeParseJSON */.NXl)(componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfjson);
    const gradientDictionary = {
        topToBottom: "top-bottom",
        bottomToTop: "bottom-top",
        leftToRight: "left-right",
        rightToLeft: "right-left",
        radialCenterOut: "tint"
    };
    const ctatitle = parsedXFJSON ? (0,textUtils/* sanitizeText */.o)(parsedXFJSON === null || parsedXFJSON === void 0 ? void 0 : parsedXFJSON.ctaLabel) : "";
    const titleforPrmobanner = parsedXFJSON ? (0,textUtils/* sanitizeText */.o)(parsedXFJSON === null || parsedXFJSON === void 0 ? void 0 : parsedXFJSON.title) : "";
    const promoEventInfo = getPromoEventInfo(ctatitle.toLowerCase(), actionLink);
    const buildAriaLabel = function() {
        let ctaTitle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        const cta = ctaTitle.trim();
        let ctx = context;
        const newctx = ctx.toLowerCase();
        if (newctx.startsWith("explore")) {
            ctx = newctx.replace("explore", "").trim();
        }
        const normalized = cta.toLowerCase();
        if (normalized.includes("shop")) return "".concat(cta, " for ").concat(ctx);
        if (normalized.includes("learn more")) return "".concat(cta, " about ").concat(ctx);
        if (normalized.includes("read more")) return "".concat(cta, " about ").concat(ctx);
        if (normalized.includes("view")) return "View ".concat(ctx);
        if (normalized.includes("explore")) return "Explore ".concat(ctx);
        // safe fallback
        return "".concat(cta, " for ").concat(ctx);
    };
    // Helper function to normalize text placement values
    const normalizeTextPlacement = (contentPosition)=>{
        if (!contentPosition) return "";
        const sanitized = (0,textUtils/* sanitizeText */.o)(contentPosition);
        if (!sanitized) return "";
        return sanitized === "dead-center" ? "center" : sanitized;
    };
    // Function to create promo props with calculated sequential index
    const createPromoProps = (productIndex)=>{
        var ref, ref1;
        // Calculate promo index based on product position
        // Promos appear every `position` products, so we can calculate the sequence number
        const promoSequenceNumber = Math.floor((productIndex + 1) / position);
        const promoComponentInfo = {
            componentID:  true && window.location.href,
            componentLocation:  true && window.location.pathname.includes("search") ? "search results:promo tiles" : "plp:promo tiles",
            componentMessage: "promo-".concat(promoSequenceNumber),
            componentName: (ref = (0,textUtils/* sanitizeText */.o)(parsedXFJSON === null || parsedXFJSON === void 0 ? void 0 : parsedXFJSON.title)) === null || ref === void 0 ? void 0 : ref.replace(/<\/?[^>]+(>|$)/g, " ").replace(/(\r\n|\n|\r)/gm, " ").replace(/&nbsp;/g, " ").toLowerCase(),
            componentType: "internal campaign"
        };
        return {
            heading: {
                text: parsedXFJSON ? (0,textUtils/* sanitizeText */.o)(parsedXFJSON === null || parsedXFJSON === void 0 ? void 0 : parsedXFJSON.title) : ""
            },
            image: {
                src: parsedXFJSON ? (0,textUtils/* sanitizeText */.o)(parsedXFJSON === null || parsedXFJSON === void 0 ? void 0 : parsedXFJSON.imageUrl) : "",
                "data-mode": "smartcrop",
                alt: parsedXFJSON ? (0,textUtils/* sanitizeText */.o)(parsedXFJSON === null || parsedXFJSON === void 0 ? void 0 : parsedXFJSON.altText) : "",
                role: "presentation"
            },
            CTA: {
                text: ctatitle,
                href: actionLink,
                target: (parsedXFJSON === null || parsedXFJSON === void 0 ? void 0 : parsedXFJSON.isNewTab) === "true" ? "_blank" : "_self",
                "aria-label": buildAriaLabel(ctatitle, titleforPrmobanner),
                trackingAttributes: {
                    "data-datalayer-id": "kds-element-promotile",
                    "data-datalayer-data": JSON.stringify(promoEventInfo) || "",
                    "data-datalayer-component": JSON.stringify(promoComponentInfo) || ""
                }
            },
            textPlacement: normalizeTextPlacement(parsedXFJSON === null || parsedXFJSON === void 0 ? void 0 : parsedXFJSON.contentPosition),
            gradientDirection: parsedXFJSON ? (0,textUtils/* sanitizeText */.o)(gradientDictionary[parsedXFJSON === null || parsedXFJSON === void 0 ? void 0 : (ref1 = parsedXFJSON.gradientPosition) === null || ref1 === void 0 ? void 0 : ref1[0]]) : "",
            opacity: 45,
            type: (0,utils_product/* getPromoType */.g6)(promoCols[componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoLayout]),
            mod: "black",
            style: (()=>{
                if (promoCols[componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoLayout].includes("2")) {
                    return {
                        aspectRatio: "2 / 1"
                    };
                } else if (promoCols[componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoLayout].includes("3")) {
                    return {
                        aspectRatio: "3 / 1"
                    };
                } else {
                    return {
                        aspectRatio: "1 / 1"
                    };
                }
            })()
        };
    };
    const tiles = (0,react.useMemo)(()=>{
        // Filter promos: hide if hidePromo is anything other than "false"
        const filteredPromos = ((componentProps === null || componentProps === void 0 ? void 0 : componentProps.promos) || []).filter((promo)=>promo.hidePromo === "false");
        const promoMap = (0,utils_product/* processPromos */.rs)(filteredPromos);
        // 2. Merge products and the promo map to get the final tile list
        // CRITICAL FIX: Pass 'width' to placePromos to enable responsive layout logic
        return (0,utils_product/* placePromos */.lH)(propsProductCard, promoMap, width);
    }, [
        propsProductCard,
        componentProps === null || componentProps === void 0 ? void 0 : componentProps.promos,
        width
    ]);
    (0,react.useEffect)(()=>{
        // Debug logs for promoLinks effect
        // 1. Resolve promo links for each tile after tiles are set
        const promoTiles = tiles.filter((tile)=>{
            return tile === null || tile === void 0 ? void 0 : tile.ctaUrl;
        });
        // 2. Iterate over promotional tiles
        promoTiles.forEach((tile)=>{
            // 3. Check if the shortened URL is already in the state
            if (!promoLinks[tile.ctaUrl]) {
                // 4. Call getCtalink to initiate the asynchronous shortening process
                getCtalink(tile.ctaUrl);
            }
        });
    }, [
        tiles,
        promoLinks
    ]);
    (0,react.useEffect)(()=>{
        document.addEventListener("click", handlePromoTileDatalayerClick);
        return ()=>document.removeEventListener("click", handlePromoTileDatalayerClick);
    }, []);
    const isDevicePresent = getIsPresentOnDeviceStatus;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const getCtalink = (url)=>{
        if (!url) return "";
        if (promoLinks[url]) return promoLinks[url];
        (0,utils_location/* getShortenedUrl */.Pp)(url).then((res)=>{
            setPromoLinks((prev)=>({
                    ...prev,
                    [url]: res
                }));
        });
        return url;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ProductList_module_default()).productListWrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-listing white-mod",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SortUI, {
                        propsSortUI: propsSortUI
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-plp-container product-listing__tiles",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-listing__row d-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "filter-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: filterClass,
                                        "aria-modal": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-listing__filter--sticky",
                                            children: propsFilters && Object.keys(propsFilters).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_FiltersUI, {
                                                propsScroll: propsScroll,
                                                propsFilters: propsFilters,
                                                propsSortUI: propsSortUI,
                                                isMobileViewport: isMobileViewport
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: tileClass,
                                        children: [
                                            (propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-listing__no-results",
                                                "data-testid": "no-results-message",
                                                dangerouslySetInnerHTML: {
                                                    __html: browser_default().sanitize(t("kf.plp.label.noResultsMssg"))
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-listing__row row-cols-responsive",
                                                children: componentProps.addMultiPromo !== "true" ? propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.map((product, i)=>{
                                                    var ref;
                                                    if (productCardSKUs.indexOf(product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.sku) === -1) {
                                                        var ref1, ref2, ref3;
                                                        productCardSKUs.push(product === null || product === void 0 ? void 0 : (ref1 = product.product) === null || ref1 === void 0 ? void 0 : ref1.sku);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-listing__tile",
                                                                    id: product === null || product === void 0 ? void 0 : (ref2 = product.product) === null || ref2 === void 0 ? void 0 : ref2.sku,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_ProductCardUI, {
                                                                        propsProductCard: product,
                                                                        handleOnClickPartsDiagramLink: handleOnClickPartsDiagramLink,
                                                                        index: i
                                                                    })
                                                                }),
                                                                componentProps.xfLink && isDevicePresent && (()=>{
                                                                    if (shouldRepeatPromo) {
                                                                        return (i + 1) % position === 0 && ((propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.length) > 11 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "".concat(promoCols[componentProps.promoLayout], " product-listing__tile"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionalTilePLP/* PromotionalTilePLP */.M, {
                                                                                    ...createPromoProps(i)
                                                                                })
                                                                            })
                                                                        }) : (propsProductCard === null || propsProductCard === void 0 ? void 0 : propsProductCard.length) - 1 === i && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "".concat(promoCols[componentProps.promoLayout], " product-listing__tile"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionalTilePLP/* PromotionalTilePLP */.M, {
                                                                                    ...createPromoProps(i)
                                                                                })
                                                                            })
                                                                        }));
                                                                    } else {
                                                                        return i + 1 === position && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "".concat(promoCols[componentProps.promoLayout], " product-listing__tile"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionalTilePLP/* PromotionalTilePLP */.M, {
                                                                                    ...createPromoProps(i)
                                                                                })
                                                                            })
                                                                        });
                                                                    }
                                                                })()
                                                            ]
                                                        }, "".concat(i, "-").concat(product === null || product === void 0 ? void 0 : (ref3 = product.title) === null || ref3 === void 0 ? void 0 : ref3.text));
                                                    }
                                                }) : tiles === null || tiles === void 0 ? void 0 : tiles.map((tile, i)=>{
                                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((tile === null || tile === void 0 ? void 0 : (ref = tile.productCardProps) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.sku) ? "" : (0,utils_product/* getPromoClass */.YG)(width, tile === null || tile === void 0 ? void 0 : tile.promoLayout), " product-listing__tile"),
                                                            id: tile === null || tile === void 0 ? void 0 : (ref2 = tile.productCardProps) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.product) === null || ref3 === void 0 ? void 0 : ref3.sku,
                                                            children: (tile === null || tile === void 0 ? void 0 : (ref4 = tile.productCardProps) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.product) === null || ref5 === void 0 ? void 0 : ref5.sku) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_ProductCardUI, {
                                                                propsProductCard: tile === null || tile === void 0 ? void 0 : tile.productCardProps,
                                                                handleOnClickPartsDiagramLink: handleOnClickPartsDiagramLink,
                                                                index: i
                                                            }) : (tile === null || tile === void 0 ? void 0 : tile.ctaUrl) && !promoLinks[tile === null || tile === void 0 ? void 0 : tile.ctaUrl] ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-listing__tile--loading",
                                                                children: "Loading..."
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionalTilePLP/* PromotionalTilePLP */.M, {
                                                                CTA: {
                                                                    text: tile === null || tile === void 0 ? void 0 : tile.ctaText,
                                                                    target: (tile === null || tile === void 0 ? void 0 : tile.isNewTab) === "true" ? "_blank" : "_self",
                                                                    href: (tile === null || tile === void 0 ? void 0 : tile.ctaUrl) ? promoLinks[tile === null || tile === void 0 ? void 0 : tile.ctaUrl] : actionLink,
                                                                    "aria-label": buildAriaLabel(tile === null || tile === void 0 ? void 0 : tile.ctaText, (0,textUtils/* sanitizeText */.o)(tile === null || tile === void 0 ? void 0 : tile.heading)),
                                                                    trackingAttributes: {
                                                                        "data-datalayer-id": "kds-element-promotile",
                                                                        "data-datalayer-data": JSON.stringify(getPromoEventInfo(((tile === null || tile === void 0 ? void 0 : tile.ctaText) || "").toLowerCase(), (tile === null || tile === void 0 ? void 0 : tile.ctaUrl) ? promoLinks[tile === null || tile === void 0 ? void 0 : tile.ctaUrl] : actionLink)) || "",
                                                                        "data-datalayer-component": JSON.stringify({
                                                                            componentID:  true && window.location.href,
                                                                            componentLocation:  true && window.location.pathname.includes("search") ? "search results:promo tiles" : "plp:promo tiles",
                                                                            componentMessage: "promo-".concat(i),
                                                                            componentName: (ref6 = (0,textUtils/* sanitizeText */.o)(tile === null || tile === void 0 ? void 0 : tile.heading)) === null || ref6 === void 0 ? void 0 : ref6.replace(/<\/?[^>]+(>|$)/g, " ").replace(/(\r\n|\n|\r)/gm, " ").replace(/&nbsp;/g, " ").toLowerCase(),
                                                                            componentType: "internal campaign"
                                                                        }) || ""
                                                                    }
                                                                },
                                                                textPlacement: (0,textUtils/* sanitizeText */.o)(tile === null || tile === void 0 ? void 0 : tile.textPlacement),
                                                                gradientDirection: tile === null || tile === void 0 ? void 0 : tile.gradientDirection,
                                                                opacity: tile === null || tile === void 0 ? void 0 : tile.opacity,
                                                                heading: {
                                                                    text: (0,textUtils/* sanitizeText */.o)(tile === null || tile === void 0 ? void 0 : tile.heading)
                                                                },
                                                                image: {
                                                                    src: (0,helper/* scene7ImageUrl */.Sp5)(tile === null || tile === void 0 ? void 0 : tile.image, scene7BaseUrl, dmScene7AccountName),
                                                                    "data-mode": "smartcrop",
                                                                    alt: (0,textUtils/* sanitizeText */.o)(tile === null || tile === void 0 ? void 0 : tile.imageAltText),
                                                                    role: "presentation"
                                                                },
                                                                style: {
                                                                    aspectRatio: ((ref7 = (0,utils_product/* getPromoClass */.YG)(width, tile === null || tile === void 0 ? void 0 : tile.promoLayout)) === null || ref7 === void 0 ? void 0 : ref7.includes("2")) ? "2 / 1" : ((ref8 = (0,utils_product/* getPromoClass */.YG)(width, tile === null || tile === void 0 ? void 0 : tile.promoLayout)) === null || ref8 === void 0 ? void 0 : ref8.includes("3")) ? "3 / 1" : "1 / 1"
                                                                },
                                                                mod: "black",
                                                                type: "1-column"
                                                            })
                                                        })
                                                    }, "".concat(i, "-").concat(tile === null || tile === void 0 ? void 0 : (ref9 = tile.title) === null || ref9 === void 0 ? void 0 : ref9.text));
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                                                ...propsPagination
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                productId: partData === null || partData === void 0 ? void 0 : partData.productId,
                partId: partData === null || partData === void 0 ? void 0 : partData.partId,
                showModal: partData === null || partData === void 0 ? void 0 : partData.isShowModal,
                page: "PLP results",
                onClose: onCloseModal,
                fileMap: svgFileMap
            })
        ]
    });
};
ProductListUI.propTypes = productListUIProps;
/* harmony default export */ var ui_ProductListUI = (ProductListUI);

// EXTERNAL MODULE: ./hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83886);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/ApiUtil.js
var ApiUtil = __webpack_require__(51666);
;// CONCATENATED MODULE: ./services/client/plp.client.js








const getListFromClient = async (profileName, params, isServiceParts, plpServletPath)=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const config = await (0,constants_config/* getConfig */.i)();
    var ref6;
    const language = (ref6 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref6 !== void 0 ? ref6 : "en";
    var ref7;
    const canadianPrice = (ref7 = config === null || config === void 0 ? void 0 : (ref1 = config.apiEndPointData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2.canadianPrice) !== null && ref7 !== void 0 ? ref7 : null;
    const isCanadaCheck = (0,helper/* isCanadaSite */.guj)(config === null || config === void 0 ? void 0 : (ref3 = config.general) === null || ref3 === void 0 ? void 0 : ref3.siteName);
    const { general: { serviceParts ="" , siteName ="" , disableCommerce , swatchUrl  } = {} , general , presetConfigs: { plp: plpPresetConfig = {}  } = {} , plpConfigurations: { myArrayList: plpBadgeList = []  } = {}  } = config;
    const collections = isServiceParts ? serviceParts : "";
    const persona = (0,helper/* getUserPersona */.shu)();
    const accessToken = (ref4 = (0,helper/* getAccessToken */.hPi)()) === null || ref4 === void 0 ? void 0 : ref4.token;
    var ref8;
    const plpRequestParams = {
        ...params,
        sort: (ref8 = (0,plpResponseProcessor/* getFacetFieldWithLabel */.ei)(params === null || params === void 0 ? void 0 : params.sort, persona, isCanadaCheck)) !== null && ref8 !== void 0 ? ref8 : (ref5 = params.sort) === null || ref5 === void 0 ? void 0 : ref5.replace(/\+/g, " "),
        sessionId: (0,ApiUtil/* getSessionIdObjWithEpoc */.oq)()
    };
    const configParams = {
        configdata: {
            plpBadgeList,
            disableCommerce,
            canadianPrice
        },
        swatchUrl,
        plpServletPath,
        general
    };
    if (collections) plpRequestParams.collections = collections;
    if (canadianPrice) plpRequestParams.CanadianPrice = canadianPrice;
    if (typeof plpRequestParams.sort === "string" && plpRequestParams.sort === "") {
        delete plpRequestParams.sort;
    }
    if (!plpRequestParams.fq) {
        plpRequestParams.fq = "language_s:".concat(language);
    }
    if (typeof plpRequestParams.fq === "string" && plpRequestParams.fq.length > 0) {
        plpRequestParams.fq = [
            plpRequestParams.fq,
            "language_s:".concat(language)
        ];
    } else if (Array.isArray(plpRequestParams.fq)) {
        plpRequestParams.fq = [
            ...plpRequestParams.fq,
            "language_s:".concat(language)
        ];
    }
    const url = (0,utils_product/* addCollectionParam */.j6)("".concat(constants.PLP_END_POINT_CLIENT, "?profilename=").concat(profileName, "&persona=").concat(persona), siteName);
    api/* aemAxiosInstance.defaults.headers.common.Authorization */.Gb.defaults.headers.common.Authorization = "Bearer ".concat(accessToken);
    try {
        const response = await api/* apim.get */.TH.get(url, {
            params: plpRequestParams,
            paramsSerializer: (params)=>{
                return lib_default().stringify(params, {
                    arrayFormat: "repeat",
                    encode: false
                });
            }
        });
        const formattedData = await (0,utils_product/* formatListingData */.nx)(response === null || response === void 0 ? void 0 : response.data, false);
        const plpData = await (0,plpResponseProcessor/* getPlpProcessedData */.dY)(formattedData, false, [], "", configParams, plpPresetConfig);
        return plpData;
    } catch (error) {
        throw new Error(error);
    }
};

// EXTERNAL MODULE: ./components/ProductList/v3/analytics/PLPFilterAnalytics.js
var PLPFilterAnalytics = __webpack_require__(89150);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/UIAnimations/Spinner/Spinner.mjs + 1 modules
var Spinner = __webpack_require__(3726);
// EXTERNAL MODULE: ./utils/announceForAccessibility.js
var announceForAccessibility = __webpack_require__(67318);
;// CONCATENATED MODULE: ./components/ProductList/v3/ProductList.jsx
























const propsScroll = {
    type: "auto",
    scrollbars: "y",
    scrollHideDelay: 500
};
const ProductList = ()=>{
    const { plpLocalState , setPlpLocalState , setPromoInfo , componentProps , isAuthenticated , deviceType , isServerData , isFromVisualNav , general: { siteName ="" , scene7BaseUrl ="" , dmScene7AccountName =""  } = {}  } = useProductContext();
    const [width] = (0,useWindowResize/* default */.Z)();
    const persona = (0,helper/* getUserPersona */.shu)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const isCanadaCheck = (0,helper/* isCanadaSite */.guj)(siteName);
    // Update swatches using getSwatchCount after all cards/data are loaded (first load)
    (0,react.useEffect)(()=>{
        if (!plpLocalState.cardsData || !Array.isArray(plpLocalState.cardsData)) return;
        setPlpLocalState((prev)=>{
            const allowedColorCount = (0,helper/* getSwatchCount */.m3S)(true);
            const swatchUrl = (componentProps === null || componentProps === void 0 ? void 0 : componentProps.swatchUrl) || "";
            const updatedCards = prev.cardsData.map((card)=>{
                // Use colorFetcheslogic to generate swatch objects like plpResponseProcessor
                const swatches = (0,plpResponseProcessor/* colorFetcheslogic */.Ev)(card.product ? card.product : card, width, swatchUrl);
                let extraColors = 0;
                if (swatches.length > allowedColorCount) {
                    extraColors = swatches.length - allowedColorCount;
                }
                return {
                    ...card,
                    productDetails: {
                        ...card.productDetails,
                        colorSwatches: {
                            ...card.productDetails.colorSwatches,
                            colors: swatches.slice(0, allowedColorCount),
                            extraColors
                        }
                    }
                };
            });
            return {
                ...prev,
                cardsData: updatedCards
            };
        });
    // Update on every window resize
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        width
    ]);
    const isSsr = (0,useIsSsr/* default */.Z)();
    const hasMounted = (0,react.useRef)(false);
    const { t  } = (0,esm/* useTranslation */.$G)();
    // Get values from plpLocalState
    const { cardsData , promoData , isGrouped , facetLabels , selectedFilterArray , filterQuery , selectSort , facets , colorLabels , defaultProductsCount , isLoading  } = plpLocalState;
    const { categoryKey , attributevalue , attributeName , isServiceParts ="" , presentOnMobile ="" , repeatPromo =false  } = componentProps;
    const deviceStatus = (0,react.useMemo)(()=>(0,utils_product/* getIsPresentOnDevice */.MO)(presentOnMobile), [
        presentOnMobile
    ]);
    const [getIsPresentOnDeviceStatus, setGetIsPresentOnDeviceStatus] = (0,react.useState)(deviceStatus);
    const initialPartData = {
        productId: "",
        partId: "",
        isShowModal: false
    };
    const [partsData, setPartsData] = (0,react.useState)({
        ...initialPartData
    });
    const [svgFileMap, setSvgFileMap] = (0,react.useState)([]);
    const [currentPerPage, setCurrentPerPage] = (0,react.useState)(defaultProductsCount);
    const [linkCopied, setLinkCopied] = (0,react.useState)(false);
    const [pageState, setPageState] = (0,react.useState)("");
    const [refreshFilters, setRefreshFilters] = (0,react.useState)(0);
    const [announceResultsAfterClear, setAnnounceResultsAfterClear] = (0,react.useState)(false);
    const [statusMessage, setStatusMessage] = (0,react.useState)("");
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const [rowCols, setRowCols] = (0,react.useState)(width < 1024 ? 2 : 3);
    const [isFilterVisible, setIsFilterVisible] = (0,react.useState)(deviceType === constants.DEVICE_TYPE_DESKTOP);
    const [isShareCTA, setIsShareCTA] = (0,react.useState)(false);
    const [scrollPosition, setScrollPosition] = (0,react.useState)(0);
    // calculate promo position
    const [promoCols, setPromoCols] = (0,react.useState)((0,utils_product/* getPromoColumns */.fi)(width));
    const isMobileViewport = width < 1024;
    const colVal = {
        "one-column": 1,
        "two-column": 2,
        "three-column": 3
    };
    const position = width > 0 && (componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoLayout) ? (0,utils_product/* getPromoTilePosition */.Ls)(parseInt(componentProps.promoPlacementDesktop), componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoLayout, width) : null;
    // When user logged in after client interaction
    (0,react.useEffect)(()=>{
        if (isAuthenticated && !isServerData) {
            // User just logged in
            fetchData({
                facetsString: filterQuery,
                selectSort
            }, 0, currentPerPage, null, persona);
        }
    }, [
        isAuthenticated
    ]);
    const handlePageShow = (e)=>{
        if (!lib/* isSafari */.G6 || !e.persisted) return;
        // Allow Safari to restore scroll first
        setTimeout(()=>{
            requestAnimationFrame(()=>{
                const scroller = document.scrollingElement;
                document.querySelectorAll("img").forEach((img)=>{
                    if (!img.complete && img.src) {
                        const src = img.src;
                        img.src = "";
                        img.src = src;
                    }
                });
                if (!scroller) return;
                // 🔥 temporarily nudge the real scroll container
                const prevOverflow = scroller.style.overflow;
                scroller.style.overflow = "hidden";
                scroller.offsetHeight // force reflow
                ;
                setTimeout(()=>{
                    scroller.style.overflow = prevOverflow || "auto";
                }, 100);
            });
        }, 500) // 👈 critical delay
        ;
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("click", analytics/* handlePLPDataLayer */._d);
        return ()=>{
            document.removeEventListener("click", analytics/* handlePLPDataLayer */._d);
        };
    }, []);
    const isRestoringFromPDP = (0,react.useRef)(false);
    (0,react.useEffect)(()=>{
        if (false) {}
        const clearPlpLoader = async ()=>{
            setPlpLocalState((prev)=>{
                return (prev === null || prev === void 0 ? void 0 : prev.isLoading) ? {
                    ...prev,
                    isLoading: false
                } : prev;
            });
            try {
                await removeItem("fromPDP");
            } catch (e) {
            /* ignore errors from storage */ }
        };
        const onPageShow = (e)=>{
            if (e && e.persisted) {
                clearPlpLoader();
                if (width < 1024) {
                    handlePageShow(e);
                }
            } else {
                const overlay = document.querySelector(".spinner-overlay");
                if (overlay) clearPlpLoader();
            }
        };
        const onVisibility = ()=>{
            if (document.visibilityState === "visible") {
                const overlay = document.querySelector(".spinner-overlay");
                if (overlay) clearPlpLoader();
            }
        };
        const onPopState = ()=>{
            const overlay = document.querySelector(".spinner-overlay");
            if (overlay) clearPlpLoader();
        };
        window.addEventListener("pageshow", onPageShow);
        document.addEventListener("visibilitychange", onVisibility);
        window.addEventListener("popstate", onPopState);
        return ()=>{
            window.removeEventListener("pageshow", onPageShow);
            document.removeEventListener("visibilitychange", onVisibility);
            window.removeEventListener("popstate", onPopState);
        };
    }, [
        setPlpLocalState
    ]);
    (0,react.useEffect)(()=>{
        let timeoutId;
        if (true) {
            // Update indexDB and fetch data
            const fetchDataAsync = async ()=>{
                const fromPDP = await getItem("fromPDP");
                const plpCardsData = await getItem("plpCardsData+".concat(window.location.href));
                const plpCardsDataLength = await getItem("plpCardsDataLength+".concat(window.location.pathname));
                const isServerSideData = await getItem("isServerData");
                if (fromPDP && plpCardsData) {
                    isRestoringFromPDP.current = true;
                    // Run your logic here (e.g., scroll to product, reload, etc.)
                    setPlpLocalState((prev)=>({
                            ...prev,
                            isLoading: true,
                            cardsData: JSON.parse(plpCardsData),
                            plpData: JSON.parse(plpCardsData)
                        }));
                    setCurrentPerPage(plpCardsDataLength);
                    dispatch((0,productListSlice/* setServerData */.NY)(isServerSideData === "true"));
                    setPageState("");
                    timeoutId = setTimeout(async ()=>{
                        await removeItem("fromPDP");
                        await removeItem("plpCardsData+".concat(window.location.href));
                        await removeItem("plpsku");
                        setPlpLocalState((prev)=>({
                                ...prev,
                                isLoading: false
                            }));
                        setTimeout(()=>{
                            isRestoringFromPDP.current = false;
                        }, 1000);
                    }, 500);
                } else {
                    await setItem("plpCardsDataLength+".concat(window.location.pathname), 30);
                }
            };
            fetchDataAsync();
        }
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);
    /**
   * based on width, we will set the rowCols and promoCols
   */ (0,react.useEffect)(()=>{
        if (width < 1024) {
            setRowCols(2);
            setIsFilterVisible(false);
            // If the width is less than or equal to 1280, we will limit the color swatches to 5
            // Update cardsData through plpLocalState
            setPlpLocalState((prev)=>{
                var ref;
                const updatedCards = (ref = prev.cardsData) === null || ref === void 0 ? void 0 : ref.map((card)=>{
                    var ref, ref1;
                    const colors = card === null || card === void 0 ? void 0 : (ref = card.productDetails) === null || ref === void 0 ? void 0 : (ref1 = ref.colorSwatches) === null || ref1 === void 0 ? void 0 : ref1.colors;
                    if ((colors === null || colors === void 0 ? void 0 : colors.length) > 5) {
                        return {
                            ...card,
                            productDetails: {
                                ...card.productDetails,
                                colorSwatches: {
                                    ...card.productDetails.colorSwatches,
                                    colors: colors.slice(0, -2),
                                    extraColors: colors.length - 5
                                }
                            }
                        };
                    }
                    return card;
                });
                return {
                    ...prev,
                    cardsData: updatedCards
                };
            });
        } else {
            setRowCols(3);
            setIsFilterVisible(true);
        }
        setPromoCols((0,utils_product/* getPromoColumns */.fi)(width));
    }, [
        width
    ]);
    (0,react.useEffect)(()=>{
        setGetIsPresentOnDeviceStatus((0,utils_product/* getIsPresentOnDevice */.MO)(componentProps === null || componentProps === void 0 ? void 0 : componentProps.presentOnMobile));
    }, [
        componentProps === null || componentProps === void 0 ? void 0 : componentProps.presentOnDesktop,
        componentProps === null || componentProps === void 0 ? void 0 : componentProps.presentOnMobile
    ]);
    const filterClass = classnames_default()({
        "product-listing__filter": true,
        "product-listing__filter--hide": !isFilterVisible,
        "product-listing__filter--modal": isFilterVisible
    });
    const tileClass = classnames_default()({
        "product-listing__tile-col": true,
        "product-listing__tile-col--full-width": !isFilterVisible
    });
    const handleBackToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        // Move focus to the top element
        setTimeout(()=>{
            var ref;
            // Focus on the product list wrapper or its parent heading
            const productListElement = (ref = document.getElementsByClassName("visualNavWrapper")[0]) !== null && ref !== void 0 ? ref : document.getElementsByClassName("productListWrapper")[0];
            if (productListElement) {
                productListElement.setAttribute("tabindex", "-1");
                productListElement.focus({
                    preventScroll: true
                });
                // Clean up tabindex after blur
                productListElement.addEventListener("blur", ()=>{
                    productListElement.removeAttribute("tabindex");
                }, {
                    once: true
                });
            }
        }, 500);
    };
    const propsPagination = {
        mod: "white",
        ...plpLocalState.plpTotal > 30 && {
            viewLabel: t("kf.plp.label.view"),
            currentPerPage: currentPerPage,
            perPageCTAs: [
                {
                    value: 30,
                    "aria-label": t("kf.plp.label.view") + " 30 " + t("kf.plp.label.results")
                },
                {
                    value: 60,
                    "aria-label": t("kf.plp.label.view") + " 60 " + t("kf.plp.label.results")
                },
                {
                    value: 90,
                    "aria-label": t("kf.plp.label.view") + " 90 " + t("kf.plp.label.results")
                }
            ],
            onPerPageClicked: (e)=>{
                // Check if new value is less than previous value
                if (e < currentPerPage) {
                    // Scroll to top of product list
                    if (true) {
                        setTimeout(()=>{
                            var ref;
                            const productListElement = (ref = document.getElementsByClassName("kohler-visual-filter-root")[0]) !== null && ref !== void 0 ? ref : document.getElementsByClassName("productListWrapper")[0];
                            if (productListElement) {
                                productListElement.scrollIntoView({
                                    behavior: "smooth"
                                });
                            }
                        }, 100);
                    }
                }
                setCurrentPerPage(e);
                setItem("plpCardsDataLength+".concat(window.location.pathname), e);
                setPageState("pagination");
                fetchData({
                    facetsString: filterQuery,
                    selectSort
                }, 0, e, null, persona);
                dispatch((0,productListSlice/* setServerData */.NY)(false));
                (0,analytics/* getPLPPaginationAnalyticsData */.y_)(e);
            }
        },
        backToTopCTA: {
            label: t("kf.plp.label.backToTop"),
            "aria-label": "Back to results",
            onClick: ()=>{
                handleBackToTop();
                (0,analytics/* addBackToTopAnalytics */.sF)(false, "plp");
            }
        },
        ...plpLocalState.plpTotal > 30 && (plpLocalState === null || plpLocalState === void 0 ? void 0 : plpLocalState.plpTotal) !== (cardsData === null || cardsData === void 0 ? void 0 : cardsData.length) && {
            loadMoreCTA: {
                text: t("kf.plp.label.loadMore"),
                "aria-label": "".concat(t("kf.plp.label.loadMore"), " Products"),
                onClick: ()=>{
                    fetchData({
                        facetsString: filterQuery,
                        selectSort
                    }, cardsData.length, "30", "loadMore", persona);
                    dispatch((0,productListSlice/* setServerData */.NY)(false));
                    setCurrentPerPage(30 + cardsData.length);
                    setPageState("loadMore");
                    (0,analytics/* addLoadMoreAnalytics */.Gd)("plp");
                }
            }
        }
    };
    (0,react.useEffect)(()=>{
        setGetIsPresentOnDeviceStatus((0,utils_product/* getIsPresentOnDevice */.MO)(componentProps === null || componentProps === void 0 ? void 0 : componentProps.presentOnMobile));
    }, [
        componentProps
    ]);
    const onCloseModal = ()=>{
        setPartsData({
            ...initialPartData,
            isShowModal: false
        });
        if (scrollPosition) {
            window.scrollTo({
                top: parseInt(scrollPosition, 10),
                behavior: "instant"
            });
        }
        setScrollPosition(0);
    };
    const handleOnClickPartsDiagramLink = (0,react.useCallback)((data)=>{
        const scrollY = window === null || window === void 0 ? void 0 : window.scrollY;
        const getPartId = data.resourceName;
        const resourceTitles = data.resourceTitle;
        const partId = Array.isArray(getPartId) ? getPartId[0] : getPartId;
        setPartsData({
            partId,
            productId: data === null || data === void 0 ? void 0 : data.productNo,
            isShowModal: true
        });
        const partLinks = (0,helper/* organizeData */.U2t)(getPartId, resourceTitles, "Service Parts Diagram", "PART");
        setSvgFileMap(partLinks);
        setScrollPosition(scrollY);
    }, []);
    (0,react.useEffect)(()=>{
        if (pageState === "loadMore") {
            setItem("plpCardsDataLength+".concat(window.location.pathname), currentPerPage);
        }
    }, [
        pageState,
        currentPerPage
    ]);
    const fetchData = (0,react.useCallback)(async function(param) {
        let { facetsString , selectSort  } = param, start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, rows = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 30, perpageclick = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, persona = arguments.length > 4 ? arguments[4] : void 0;
        const params = {
            fq: [
                ...(0,plpResponseProcessor/* reformatFacetString */.V9)(facetsString, facetLabels, persona, isCanadaCheck)
            ],
            rows: rows,
            start: start,
            fl: constants.resourceFacetLabels.join(","),
            sort: selectSort
        };
        const clientData = await getListFromClient(categoryKey, params, isServiceParts, plpLocalState === null || plpLocalState === void 0 ? void 0 : plpLocalState.plpServletPath);
        if (perpageclick === "loadMore") {
            setPlpLocalState((prev)=>{
                return {
                    ...prev,
                    cardsData: [
                        ...prev.cardsData,
                        ...(clientData === null || clientData === void 0 ? void 0 : clientData.transformedCards) || []
                    ],
                    plpData: [
                        ...prev.plpData,
                        ...(clientData === null || clientData === void 0 ? void 0 : clientData.data) || []
                    ],
                    plpTotal: clientData === null || clientData === void 0 ? void 0 : clientData.total,
                    facets: clientData === null || clientData === void 0 ? void 0 : clientData.facets,
                    colorLabels: clientData === null || clientData === void 0 ? void 0 : clientData.colors,
                    facetLabels: clientData === null || clientData === void 0 ? void 0 : clientData.facetLabels
                };
            });
        } else {
            setPlpLocalState((prev)=>{
                return {
                    ...prev,
                    cardsData: [
                        ...(clientData === null || clientData === void 0 ? void 0 : clientData.transformedCards) || []
                    ],
                    plpData: [
                        ...(clientData === null || clientData === void 0 ? void 0 : clientData.data) || []
                    ],
                    plpTotal: clientData === null || clientData === void 0 ? void 0 : clientData.total,
                    facets: clientData === null || clientData === void 0 ? void 0 : clientData.facets,
                    colorLabels: clientData === null || clientData === void 0 ? void 0 : clientData.colors,
                    facetLabels: clientData === null || clientData === void 0 ? void 0 : clientData.facetLabels
                };
            });
        }
    }, [
        filterQuery,
        constants.resourceFacetLabels,
        categoryKey,
        isServiceParts,
        plpLocalState === null || plpLocalState === void 0 ? void 0 : plpLocalState.plpServletPath,
        getListFromClient,
        setPlpLocalState,
        plpResponseProcessor/* reformatFacetString */.V9
    ]);
    const isServerDataRef = (0,react.useRef)(isServerData);
    const isFromCheckBoxClickedRef = (0,react.useRef)(true);
    (0,react.useEffect)(()=>{
        isServerDataRef.current = isServerData;
    }, [
        isServerData
    ]);
    const handleServerSidedataOnchange = (0,react.useCallback)(()=>{
        if (isServerDataRef.current) {
            isServerDataRef.current = false;
            dispatch((0,productListSlice/* setServerData */.NY)(false));
        }
    }, [
        dispatch
    ]);
    const handleActiveFiltersChange = (0,react.useCallback)((newFilters)=>{
        setPlpLocalState((prev)=>{
            const prevFilters = prev.selectedFilterArray || [];
            const added = newFilters.filter((x)=>!prevFilters.includes(x));
            const removed = prevFilters.filter((x)=>!newFilters.includes(x));
            const actionType = added.length > 0 ? "applied" : "removed";
            const changedFilter = added.length > 0 ? added[0] : removed[0];
            const filterArray = newFilters.map((item)=>{
                const [facet, value] = item.split(" - ");
                return "".concat((0,plpResponseProcessor/* isPriceRangeFilter */.w8)(facet) ? t("kf.plp.label.priceRangeTitle") : facetLabels[facet], ":").concat((0,plpResponseProcessor/* isPriceRangeFilter */.w8)(facet) ? (0,helper/* formatPriceRange */.NO1)(value) : value);
            }).join("|");
            // Only send analytics if something actually changed
            if (changedFilter && isFromCheckBoxClickedRef.current && !isServerDataRef.current) {
                const [facet, value] = changedFilter.split(" - ");
                (0,PLPFilterAnalytics/* getFilterAnalyticsForFacetCheckbox */.Db)(actionType, (0,plpResponseProcessor/* isPriceRangeFilter */.w8)(facet) ? (0,helper/* formatPriceRange */.NO1)(value) : value, (0,plpResponseProcessor/* isPriceRangeFilter */.w8)(facet) ? t("kf.plp.label.priceRangeTitle") : facetLabels[facet], filterArray);
            }
            if (JSON.stringify(prev.selectedFilterArray) !== JSON.stringify(newFilters)) {
                dispatch((0,productListSlice/* setCurrentAppliedfiltersVisualNav */._8)(newFilters));
                return {
                    ...prev,
                    selectedFilterArray: newFilters,
                    filterQuery: (0,plpResponseProcessor/* formatFacets */.ZO)(newFilters, facetLabels, attributeName, attributevalue)
                };
            }
            return prev;
        });
    }, []);
    (0,react.useMemo)(()=>{
        let timeoutId;
        if ( true && !isServerData) {
            // Update indexDB and fetch data
            const fetchDataAsync = async ()=>{
                const fromPDP = await getItem("fromPDP");
                const url = new URL(window.location.href);
                if (!fromPDP && !isRestoringFromPDP.current && (url.searchParams.has("sort") || plpLocalState.selectSort === "featured" || selectedFilterArray.length === 0 && pageState === "clearAll" || url.searchParams.has("facets"))) {
                    timeoutId = setTimeout(()=>{
                        var ref;
                        const productListElement = (ref = document.getElementsByClassName("visualNavWrapper")[0]) !== null && ref !== void 0 ? ref : document.getElementsByClassName("productListWrapper")[0];
                        if (productListElement) {
                            productListElement.scrollIntoView({
                                behavior: "smooth"
                            });
                        }
                    }, 10);
                }
            };
            fetchDataAsync();
        }
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        router,
        isServerData
    ]);
    // Helper to update the URL with only filter changes
    const updateUrlWithFilters = (filterQuery)=>{
        var ref;
        const query = {};
        if (filterQuery) {
            query.facets = filterQuery;
        }
        // Keep current sort in URL if present
        if (selectSort && selectSort !== "featured" && selectSort !== "") {
            query.sort = selectSort;
        }
        const baseUrl = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[0];
        const searchParams = Object.keys(query).length ? "?" + new URLSearchParams(query).toString() : "";
        const browserUrl = baseUrl + searchParams;
        router.replace({
            pathname: router.pathname,
            query
        }, browserUrl, {
            shallow: true
        });
        isFromVisualNav && setRefreshFilters((v)=>v + 1);
        dispatch((0,productListSlice/* setIsFromVisualNav */.zm)(false));
        dispatch((0,productListSlice/* setFilterQueryState */.nS)(filterQuery));
    };
    // Helper to update the URL with only sort changes
    const updateUrlWithSort = (sortValue)=>{
        const baseUrl = router.asPath.split("?")[0];
        const params = [];
        if (filterQuery) {
            params.push("facets=".concat(encodeURIComponent(filterQuery)));
        }
        if (sortValue && sortValue !== "featured" && sortValue !== "") {
            params.push("sort=".concat(sortValue));
        }
        const newUrl = params.length > 0 ? "".concat(baseUrl, "?").concat(params.join("&")) : baseUrl;
        const urlWithLocale = "/".concat(router.locale).concat(newUrl);
        router.replace(urlWithLocale, undefined, {
            shallow: true
        });
    };
    (0,react.useEffect)(()=>{
        if (isSsr) return;
        if (!hasMounted.current) {
            hasMounted.current = true;
            return;
        }
        // Update indexDB and fetch data
        const fetchDataAsync = async ()=>{
            const plpCardsDataLength = await getItem("plpCardsDataLength+".concat(window.location.pathname));
            const rows = plpCardsDataLength || 30;
            if (!isServerData && selectedFilterArray) {
                fetchData({
                    facetsString: filterQuery,
                    selectSort
                }, 0, rows, null, persona);
                updateUrlWithFilters(filterQuery);
            } else if (!isServerData && selectSort) {
                fetchData({
                    facetsString: filterQuery,
                    selectSort
                }, 0, rows, null, persona);
                updateUrlWithSort(selectSort);
            }
            setCurrentPerPage(rows);
        };
        fetchDataAsync();
    }, [
        selectSort,
        isSsr,
        filterQuery
    ]);
    // Announce results count after the "cleared all filters" announcement completes
    (0,react.useEffect)(()=>{
        const countMessage = "".concat(plpLocalState.plpTotal, " ").concat(t("kf.search.label.results") || "results");
        (0,announceForAccessibility/* default */.Z)(countMessage);
        if (announceResultsAfterClear) {
            // Wait for the first announcement to finish (1200ms) plus small buffer for SR
            const timeoutId = setTimeout(()=>{
                const countMessage = t("kf.plp.announce.clearAllSuccess") || "Cleared all filters successfully";
                (0,announceForAccessibility/* default */.Z)(countMessage);
                // Reset flag so it doesn't keep announcing
                setAnnounceResultsAfterClear(false);
            }, 2000);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        plpLocalState.plpTotal
    ]);
    // handle for sort
    const propsSortUI = (0,react.useMemo)(()=>(0,plpResponseProcessor/* plpSortArrayFormatter */.iG)(plpLocalState, t, isFilterVisible, setIsFilterVisible, selectSort, isGrouped, setPlpLocalState, isMobileViewport, dispatch, productListSlice/* setServerData */.NY), [
        plpLocalState,
        isFilterVisible,
        selectSort,
        isGrouped,
        isMobileViewport
    ]);
    // Handle for Filter
    const propsFilters = (0,react.useMemo)(()=>(0,plpResponseProcessor/* plpFilterArrayFormatter */.Bi)(plpLocalState, isFilterVisible, setIsFilterVisible, componentProps, t, handleServerSidedataOnchange, handleActiveFiltersChange, linkCopied, setLinkCopied, refreshFilters, isFromVisualNav, isFromCheckBoxClickedRef, dispatch, productListSlice/* setFilterQueryState */.nS, productListSlice/* setIsFromVisualNav */.zm, setPageState, isMobileViewport, setAnnounceResultsAfterClear, isShareCTA, setIsShareCTA), [
        facets,
        facetLabels,
        filterQuery,
        colorLabels,
        isFilterVisible,
        linkCopied,
        refreshFilters,
        isShareCTA
    ]);
    // if the total count changes, we want to update the status message for screen readers
    const prevPlpTotalRef = (0,react.useRef)(plpLocalState.plpTotal);
    (0,react.useEffect)(()=>{
        if (plpLocalState.plpTotal !== prevPlpTotalRef.current) {
            prevPlpTotalRef.current = plpLocalState.plpTotal;
            setStatusMessage("".concat(plpLocalState.plpTotal, " ").concat(t("kf.plp.label.results")));
        } else {
            setStatusMessage("");
        }
    }, [
        plpLocalState.plpTotal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "spinner-overlay",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                    mod: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                role: "alert",
                "aria-live": "polite",
                className: "sr-only",
                "aria-label": "".concat(statusMessage)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-testid": "product-list-wrapper",
                className: (ProductList_module_default()).productListWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "site-announcer",
                        role: "status",
                        "aria-live": "polite",
                        "aria-atomic": "true",
                        className: (ProductList_module_default()).siteAnnouncer
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_ProductListUI, {
                        propsPagination: propsPagination,
                        propsSortUI: propsSortUI,
                        propsScroll: propsScroll,
                        propsFilters: propsFilters,
                        propsProductCard: cardsData,
                        filterClass: filterClass,
                        tileClass: tileClass,
                        rowCols: rowCols,
                        width: width,
                        smartCrop: smartCrop,
                        componentProps: componentProps,
                        getIsPresentOnDeviceStatus: getIsPresentOnDeviceStatus,
                        setPromoData: setPromoInfo,
                        colVal: colVal,
                        promoData: promoData,
                        position: position,
                        promoCols: promoCols,
                        partData: partsData,
                        onCloseModal: onCloseModal,
                        svgFileMap: svgFileMap,
                        totalCount: plpLocalState.plpTotal,
                        handleOnClickPartsDiagramLink: handleOnClickPartsDiagramLink,
                        isMobileViewport: isMobileViewport,
                        repeatPromo: repeatPromo,
                        scene7BaseUrl: scene7BaseUrl,
                        dmScene7AccountName: dmScene7AccountName
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v3_ProductList = (ProductList);

;// CONCATENATED MODULE: ./components/ProductList/v3/ProductListContext.jsx










// Createcontext
const ProductContext = /*#__PURE__*/ (0,react.createContext)();
// Create custom hook for using the context
const useProductContext = ()=>{
    const context = (0,react.useContext)(ProductContext);
    if (!context) {
        throw new Error("useProductContext must be used within ProductProvider");
    }
    return context;
};
const ProductListContext = (param)=>{
    let { children , data: componentProps , eventHandler , plpData: serverPlpData , plpBadgeList: serverBadgeList , disableCommerce , swatchUrl , language , general , socialMediaConfigs , plpServletPath , facetQuery , sortQuery , locale , skuPrepend , plpPresetConfig , productsCount , deviceType , quickViewAuthData , bundleProductCardLabel  } = param;
    // Initialize state with server data
    const twitter = socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : socialMediaConfigs.myArrayList.find((socialMediaConfig)=>socialMediaConfig.map.name.toLowerCase().includes("twitter"));
    const facebook = socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : socialMediaConfigs.myArrayList.find((socialMediaConfig)=>socialMediaConfig.map.name.toLowerCase().includes("facebook"));
    const linkedin = socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : socialMediaConfigs.myArrayList.find((socialMediaConfig)=>socialMediaConfig.map.name.toLowerCase().includes("linkedin"));
    var ref;
    // session is having data
    const [plpLocalState, setPlpLocalState] = (0,react.useState)({
        promoData: {
            promos: [],
            isUpdate: false
        },
        plpData: serverPlpData === null || serverPlpData === void 0 ? void 0 : serverPlpData.data,
        cardsData: (serverPlpData === null || serverPlpData === void 0 ? void 0 : serverPlpData.transformedCards) || [],
        plpBadgeList: serverBadgeList || [],
        componentProps,
        // Include core configuration props
        disableCommerce,
        swatchUrl,
        language,
        general,
        twitter,
        facebook,
        linkedin,
        plpServletPath,
        hoverColor: false,
        selectedColor: null,
        facets: serverPlpData === null || serverPlpData === void 0 ? void 0 : serverPlpData.facets,
        facetLabels: serverPlpData === null || serverPlpData === void 0 ? void 0 : serverPlpData.facetLabels,
        colorLabels: serverPlpData === null || serverPlpData === void 0 ? void 0 : serverPlpData.colors,
        plpTotal: (ref = serverPlpData === null || serverPlpData === void 0 ? void 0 : serverPlpData.total) !== null && ref !== void 0 ? ref : 0,
        isGrouped: serverPlpData === null || serverPlpData === void 0 ? void 0 : serverPlpData.isGrouped,
        filterQuery: facetQuery ? decodeURI(facetQuery) : "",
        selectedFilterArray: [],
        selectSort: sortQuery ? decodeURI(sortQuery) : "",
        locale,
        skuPrepend,
        plpPresetConfig,
        defaultProductsCount: productsCount,
        isLoading: false
    });
    (0,react.useEffect)(()=>{
        const updatePlpLoader = async ()=>{
            const fromPDP = await getItem("fromPDP");
            setPlpLocalState((prev)=>({
                    ...prev,
                    isLoading: fromPDP ? true : prev.isLoading
                }));
        };
        updatePlpLoader();
    }, []);
    // override plpLocalState if session exist with previous state
    (0,react.useEffect)(()=>{
        // Scroll to SKU after DOM update
        requestAnimationFrame(async ()=>{
            const plpsku = await getItem("plpsku") || "";
            (0,utils_product/* handleWindowScroll */.o1)(plpsku);
        });
    }, []);
    // Handle client-side updates
    const updateClientState = (0,react.useCallback)((updates)=>{
        setPlpLocalState((prev)=>({
                ...prev,
                isServerData: false,
                ...updates
            }));
    }, []);
    // Move setPromoInfo to context
    const setPromoInfo = (0,react.useCallback)((promo)=>{
        setPlpLocalState((prev)=>{
            const promoDataNew = [
                ...prev.promoData.promos
            ];
            if (promo && !promoDataNew.find((item)=>item.position === promo.position)) {
                promoDataNew.push(promo);
            }
            return {
                ...prev,
                promoData: {
                    promos: promoDataNew,
                    isUpdate: true
                }
            };
        });
    }, []);
    // Redux selectors for client-side state
    const { isServerData , isFromVisualNav , filterQueryState , visualNavAppliedFilters  } = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv);
    const { isAuth: isAuthenticated , access_token: accessToken , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { globalConfig: { internationalization: { currencySign ="$"  } = {}  } = {} , featureFlags ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    (0,react.useEffect)(()=>{
        if (isFromVisualNav === true && filterQueryState !== "NONE") {
            setPlpLocalState((prev)=>({
                    ...prev,
                    filterQuery: decodeURI(filterQueryState)
                }));
        } else if (isFromVisualNav === false && filterQueryState === "NONE") {
            setPlpLocalState((prev)=>({
                    ...prev,
                    filterQuery: ""
                }));
        }
    }, [
        filterQueryState
    ]);
    const contextValue = (0,react.useMemo)(()=>({
            // State Management
            plpLocalState,
            setPlpLocalState,
            updateClientState,
            // Server-side Data
            componentProps,
            // Configuration
            disableCommerce: plpLocalState.disableCommerce,
            swatchUrl: plpLocalState.swatchUrl,
            language: plpLocalState.language,
            general: plpLocalState.general,
            twitter: plpLocalState.twitter,
            facebook: plpLocalState.facebook,
            linkedin: plpLocalState.linkedin,
            plpServletPath: plpLocalState.plpServletPath,
            featureFlags: featureFlags,
            plpBadgeList: plpLocalState.plpBadgeList,
            skuPrepend: plpLocalState.skuPrepend,
            plpPresetConfig: plpLocalState.plpPresetConfig,
            // Event Handlers
            eventHandler,
            setPromoInfo,
            // Authentication
            isAuthenticated,
            accessToken,
            user,
            // generic state
            currencySign,
            deviceType,
            isServerData,
            isFromVisualNav,
            filterQueryState,
            visualNavAppliedFilters,
            quickViewAuthData,
            bundleProductCardLabel
        }), [
        plpLocalState,
        setPlpLocalState,
        updateClientState,
        componentProps,
        eventHandler,
        setPromoInfo,
        isAuthenticated,
        accessToken,
        user,
        isFromVisualNav,
        filterQueryState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductList, {
            children: children
        })
    });
};
ProductListContext.propTypes = productListContextPropsType;

/* harmony default export */ var v3_ProductListContext = (ProductListContext);

// EXTERNAL MODULE: ./components/ProductList/v2/PLPLoader/index.jsx
var PLPLoader = __webpack_require__(80498);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/index.module.scss
var index_module = __webpack_require__(29472);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductTile/index.module.scss
var ProductTile_index_module = __webpack_require__(50702);
var ProductTile_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductTile_index_module);
// EXTERNAL MODULE: ./components/InstallDesignServices/v1/InstallDesignServices.jsx + 4 modules
var InstallDesignServices = __webpack_require__(97662);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/index.jsx + 1 modules
var UpsellInstallServices = __webpack_require__(61054);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordion/index.jsx + 1 modules
var ProductAccordion = __webpack_require__(30534);
;// CONCATENATED MODULE: ./pages/products/product-list.jsx





























/**
 * renders home page
 * @return {JSX.Element}
 * @param {object} props The props.
 */ const Listing = (props)=>{
    var ref, ref1, ref2;
    const { tmpData: data , headertmp: header , footertmp: footer , ip , adobeAnalytic , globalScript , footerScript , analyticsData , datalayerPageName , plpData , plpBadgeList , disableCommerce , swatchUrl , lang , general ={} , socialMediaConfigs ={} , plpServletPathArray , gbhDataLayerCustom , canonicalUrl ="" , seoPageScript ="" , breadCrumbApplicationJSonLd ="" , seoProperties , pageData , siteName , query: { facets: facetQuery , sort: sortQuery  } , templateName ="" , locale , skuPrepend , plpPresetConfig , productsCount , deviceType , facetLabelsState , bundleProductCardLabel  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const language = (0,esm/* useTranslation */.$G)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { cartUrl  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const [pageRedirect, setPageRedirect] = (0,react.useState)("");
    const [seoScripts, setSeoScript] = (0,react.useState)([]);
    const { redirectTarget: { page: { path =""  } = {}  } = {}  } = data;
    const { brandLogoImg , menu: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    (0,react.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,usePageAuth/* default */.Z)();
    const cartCount = (0,cart/* getCartCount */.c0)();
    const ariaLabel = (0,cart/* getAriaLabel */.Xw)(t, cartCount);
    (0,react.useEffect)(()=>{
        (0,helper/* getScriptsAndStyles */.csL)(footer);
    }, [
        footer
    ]);
    (0,react.useEffect)(()=>{
        (0,helper/* getAnalyticsScript */.Szq)(adobeAnalytic);
    }, [
        adobeAnalytic
    ]);
    (0,react.useEffect)(()=>{
        (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,helper/* removeAndCleanLink */.xEh)(path));
        }
    }, [
        path
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.push(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react.useEffect)(()=>{
        // if (isSsr) return
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        if (plpData) {
            dispatch((0,productListSlice/* setPlpData */.gS)({
                ...plpData,
                status: "succeeded",
                initialLoad: true
            }));
        }
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, [
        datalayerPageName,
        gbhDataLayerCustom,
        plpData
    ]);
    (0,react.useEffect)(()=>{
        dispatch((0,productListSlice/* setFacetLabels */.W1)(facetLabelsState || {}));
    }, []);
    const pageUrl = new URL(pageData === null || pageData === void 0 ? void 0 : pageData.pageUrl);
    var _origin;
    const originUrl = (_origin = pageUrl.origin) !== null && _origin !== void 0 ? _origin : "";
    const toggleMenu = ()=>{
        if (isOpen) {
            dispatch((0,genericSlice/* closeMenu */.Wj)());
            dispatch((0,genericSlice/* setAuthNav */.AT)(false));
        } else {
            dispatch((0,genericSlice/* openMenu */.qn)());
        }
    };
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            brandLogoImg: brandLogoImg,
            isOpen,
            mainCategoryActive,
            isRegionOpen,
            isAuthNavOpen,
            cartCount,
            ariaLabel,
            cartUrl,
            plp: {
                ...plpData,
                status: "succeeded"
            }
        },
        callbacks: {
            setBrandLogoImg: (path)=>{
                dispatch((0,genericSlice/* setBrandLogoImg */.XY)(path));
            },
            closeMenu: ()=>{
                dispatch((0,genericSlice/* closeMenu */.Wj)());
            },
            setMainCategory: (payload)=>{
                dispatch((0,genericSlice/* setActiveMainCategory */.X7)(payload));
            },
            toggleMenu: ()=>{
                toggleMenu();
            },
            setRegionNav: (active)=>{
                dispatch((0,genericSlice/* setRegionNav */.qX)(active));
            },
            setAuthNav: (active)=>{
                dispatch((0,genericSlice/* setAuthNav */.AT)(active));
            },
            setGlobalScripts: (item)=>{
                dispatch((0,genericSlice/* setGlobalScripts */.n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,genericSlice/* setGlobalStyles */.cw)(item));
            },
            onClick: ()=>{
                redirect();
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (seoPageScript) {
            extractSeoPageScript(seoPageScript);
        }
    }, [
        seoPageScript
    ]);
    const extractSeoPageScript = function() {
        let scriptContent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const scriptList = [];
        const doc = new DOMParser().parseFromString(scriptContent, "text/html");
        (0,helper/* extractScriptsFromDOM */.CZn)(doc, (item)=>scriptList.push(item));
        setSeoScript(scriptList);
    };
    let imageUrl = "";
    if (templateName === "category-landing-page") {
        imageUrl = pageData === null || pageData === void 0 ? void 0 : pageData.thumbnailImageUrl;
    } else if (originUrl) {
        imageUrl = "".concat(originUrl, "/_next/static/media/BLOK_LOGO.00edf835.svg");
    }
    const quickViewAuthData = (0,helper/* getQuickViewAuth */.sKe)(footer);
    if ( true && ((ref = window.kohler) === null || ref === void 0 ? void 0 : (ref1 = ref.datalayer) === null || ref1 === void 0 ? void 0 : ref1.readyState) === "ready") {
        const kohlerDatalayer = window.kohler.datalayer;
        if (analyticsData && (kohlerDatalayer === null || kohlerDatalayer === void 0 ? void 0 : kohlerDatalayer.setItem)) {
            kohlerDatalayer.setItem("PAGE_INFO", analyticsData);
            if (plpData) {
                kohlerDatalayer.setItem("PLP_LW_DATA", plpData);
            }
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    canonicalUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: (language === null || language === void 0 ? void 0 : (ref2 = language.i18n) === null || ref2 === void 0 ? void 0 : ref2.language) === "fr" ? canonicalUrl === null || canonicalUrl === void 0 ? void 0 : canonicalUrl.replace("/en/", "/fr/") : canonicalUrl
                    }) : null,
                    breadCrumbApplicationJSonLd && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: browser_default().sanitize(breadCrumbApplicationJSonLd)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader["default"], {
                        themeType: data === null || data === void 0 ? void 0 : data.appliedCssClassNames,
                        header: header,
                        title: data.title,
                        globalScripting: globalScript,
                        fullUrl: canonicalUrl,
                        siteName: siteName,
                        phone: seoProperties === null || seoProperties === void 0 ? void 0 : seoProperties.phoneNum,
                        imageUrl: imageUrl,
                        description: data === null || data === void 0 ? void 0 : data.description,
                        data: data
                    }),
                    (0,jsx_runtime.jsx)((style_default()), {
                        id: "4da4082d098430d2",
                        children: "@media print{@page{size:A4 portrait!important}}"
                    }),
                    seoScripts.map((script, i)=>!script.src && script.innerHTML ? /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                            id: "seoscript-".concat(i),
                            type: script.type,
                            "data-script-purpose": "seo",
                            children: "".concat(script.innerHTML)
                        }, "seoscript-".concat(i)) : null),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: data.id,
                        className: "jsx-4da4082d098430d2" + " " + (data.cssClassNames || ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid["default"], {
                            data: data,
                            count: 0,
                            eventHandler: eventHandler,
                            breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb["default"], {
                                    data: data,
                                    fullData: fullData,
                                    plpPage: true
                                }),
                            productAccordion: (data, fullData)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion/* default */.Z, {
                                    data: data,
                                    fullData: fullData
                                }),
                            productList: (data, eventHandler)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ProductListContext, {
                                    data: data,
                                    eventHandler: eventHandler,
                                    plpData: plpData,
                                    plpBadgeList: plpBadgeList,
                                    bundleProductCardLabel: bundleProductCardLabel,
                                    disableCommerce: disableCommerce,
                                    swatchUrl: swatchUrl,
                                    language: lang,
                                    general: general,
                                    socialMediaConfigs: socialMediaConfigs,
                                    plpServletPath: plpServletPathArray,
                                    isAuth: isAuth,
                                    facetQuery: facetQuery,
                                    sortQuery: sortQuery,
                                    locale: locale,
                                    skuPrepend: skuPrepend,
                                    plpPresetConfig: plpPresetConfig,
                                    productsCount: productsCount,
                                    deviceType: deviceType,
                                    analyticsData: analyticsData,
                                    quickViewAuthData: quickViewAuthData
                                }),
                            installDesignServices: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(InstallDesignServices/* default */.Z, {
                                    data: data
                                }),
                            productListFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-4da4082d098430d2" + " " + "".concat((index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PLPLoader/* default */.Z, {})
                                }),
                            upSellContainer: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(UpsellInstallServices/* default */.Z, {
                                    authData: data
                                })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter["default"], {
                        footer: footer,
                        footerScripting: footerScript
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var product_list = (Listing);
Listing.propTypes = listingPropTypes;


/***/ }),

/***/ 29472:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productListWrapper":"ProductListView_productListWrapper__KS0NK"};

/***/ }),

/***/ 50702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productTileWrapper":"ProductTile_productTileWrapper__SFQ2t"};

/***/ }),

/***/ 58231:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"siteAnnouncer":"ProductList_siteAnnouncer___dTrc","productListWrapper":"ProductList_productListWrapper__R3Jdj","product-listing__tile-col--full-width":"ProductList_product-listing__tile-col--full-width__L4z9u"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2857,2247,5726,1729,3147,1054,1976,7783,5395,3838,498,9774,2888,179], function() { return __webpack_exec__(77561); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);